import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import { MultiSelect } from "react-multi-select-component";
import { useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import gujaratiFont from "./GujaratiFonts";

export const notifySuccess = (message, dark) =>
  toast(<p style={{ fontSize: 14, display: "flex", justifyContent: "center", margin: "auto", fontFamily: 'Poppins, Helvetica, "sans-serif"' }}>{message}</p>, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    newestOnTop: false,
    closeOnClick: true,
    rtl: false,
    className: dark ? "custom-toast-dark" : "",
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    type: "success",
  });

export const notifyType = (message, type, dark) =>
  toast(<p style={{ fontSize: 14, display: "flex", justifyContent: "center", margin: "auto", fontFamily: 'Poppins, Helvetica, "sans-serif"', zIndex: "99999" }}>{message}</p>, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    newestOnTop: false,
    closeOnClick: true,
    rtl: false,
    className: dark ? "custom-toast-dark" : "",
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    type: type,
  });

export const notifyError = (message, dark) =>
  toast(<p style={{ fontSize: 16, display: "flex", justifyContent: "center", margin: "auto", fontFamily: 'Poppins, Helvetica, "sans-serif"' }}>{message}</p>, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    newestOnTop: false,
    closeOnClick: true,
    rtl: false,
    className: dark ? "custom-toast-dark" : "",
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    type: "error",
  });

export const PopUpMessage = async (Message, popUpType) => {
  return await Swal.fire({
    title: Message,
    icon: popUpType,
    timer: 2000,
    showConfirmButton: false,
    customClass: {
      title: "custom-title",
      popup: "custom-popup",
      icon: "custom-icon",
    },
  });
};

export const deleteConfirmation = async () => {
  const response = await Swal.fire({
    title: "Are you Sure?",
    text: "Action cannot be undone.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!",
  });
  console.log(response, "jkjkkjkj");
  return response;
};

// export const handleKeyDownNumber = (event) => {
//   const charCode = event.which || event.keyCode;
//   const eventKeys = ["v", "c", "a", "z"];

//   if (eventKeys.includes(event.key) && (event.ctrlKey || event.metaKey)) {
//     return;
//   }

//   if (!/\d/.test(event.key) && event.key !== "Backspace" && event.key !== "Delete" && charCode !== 9) {
//     event.preventDefault();
//   }
// };

export const handleKeyDownNumber = (event) => {
  const charCode = event.which || event.keyCode;
  const eventKeys = ["v", "c", "a", "z"];
  const allowedKeys = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "."];

  // Allow Ctrl/Command + (A, C, V, Z)
  if (eventKeys.includes(event.key.toLowerCase()) && (event.ctrlKey || event.metaKey)) {
    return;
  }

  // Allow specific keys
  if (allowedKeys.includes(event.key)) {
    return;
  }

  // Allow only digits 0–9
  if (!/\d/.test(event.key)) {
    event.preventDefault();
  }
};

// export const handleKeyDownString = (event) => {
//   const charCode = event.which || event.keyCode;
//   const eventKeys = ["v", "c", "a"];

//   // Allow Ctrl/⌘ + v/c/a
//   if (eventKeys.includes(event.key.toLowerCase()) && (event.ctrlKey || event.metaKey)) {
//     return;
//   }

//   // Allow letters only (a-z / A-Z)
//   if (!/^[a-zA-Z]$/.test(event.key) && event.key !== "." && event.key !== " " && event.key !== "Backspace" && event.key !== "Delete" && charCode !== 9) {
//     event.preventDefault();
//   }
// };

export const handleKeyDownString = (event) => {
  const charCode = event.which || event.keyCode;
  const eventKeys = ["v", "c", "a"];
  const allowedKeys = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", ".", " "];

  // Allow Ctrl/⌘ + v/c/a
  if (eventKeys.includes(event.key.toLowerCase()) && (event.ctrlKey || event.metaKey)) {
    return;
  }

  // Allow navigation keys and shift+arrows
  if (allowedKeys.includes(event.key)) {
    return;
  }

  // Allow letters only (a-z / A-Z)
  if (!/^[a-zA-Z]$/.test(event.key)) {
    event.preventDefault();
  }
};

export const handlePaste = (event) => {
  const pastedText = event.clipboardData.getData("text/plain");
  const isValid = /^\d+$/.test(pastedText.trim());
  if (!isValid) {
    event.preventDefault();
  }
};
export const CMFormInput = ({
  InputLabel,
  id,
  onKeyDown,
  type,
  accept,
  NoLabel,
  LabelExample,
  textArea,
  ColSize = "col-md-4 mb-4",
  oldImage,
  maxLength,
  temptVal,
  disabled,
  handleError,
  col,
  required,
  imgReg,
  handleDispatch,
  onPaste,
  multipleImage,
  customePlace,
  textAreaRows,
}) => {
  return (
    <div className={` ${ColSize}`}>
      {!NoLabel ? (
        <label className="form-label">
          {InputLabel} {LabelExample ? <span style={{ color: "#00324f", fontWeight: "bold" }}>{LabelExample}</span> : ""}
          {required && <span className="text-danger ml-1">*</span>}
        </label>
      ) : (
        ""
      )}
      {textArea ? (
        <textarea
          className="form-control"
          onKeyDown={onKeyDown || null}
          onChange={(e) => {
            handleDispatch(e);
          }}
          id={id}
          rows={textAreaRows ? textAreaRows : "4"}
          cols={col}
          value={temptVal}
          accept={accept || ""}
          onPaste={onPaste || null}
          // placeholder={customePlace ? InputLabel : `Enter ${InputLabel}`}
          placeholder={customePlace ? customePlace : `Enter ${InputLabel}`}
          maxLength={maxLength}
          name={id}
        />
      ) : (
        <>
          <input
            className="form-control"
            onKeyDown={onKeyDown || null}
            onChange={(e) => {
              handleDispatch(e);
            }}
            id={id}
            ref={imgReg || null}
            disabled={disabled}
            value={temptVal}
            multiple={multipleImage || null}
            accept={accept || null}
            type={type}
            onPaste={onPaste || null}
            placeholder={`Enter ${InputLabel}`}
            autoComplete="off"
            maxLength={maxLength}
            name={id}
          />
          <span style={{ textAlign: "left" }}>{oldImage || ""}</span>
        </>
      )}

      {handleError && handleError(id)}
    </div>
  );
};
const customStyles = {
  control: (provided) => ({
    ...provided,
    fontSize: "0.885rem",
  }),
  valueContainer: (provided) => ({
    ...provided,
    fontSize: "0.885rem",
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: "0.885rem", // <-- selected value text
  }),
  multiValue: (provided) => ({
    ...provided,
    fontSize: "0.885rem", // <-- multi-select selected chips
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "0.885rem",
  }),
  option: (provided) => ({
    ...provided,
    fontSize: "0.885rem",
  }),
};
export const CMFormDropDown = ({
  InputLabel,
  options,
  Multiple,
  requiredStar,
  ColSize = "col-md-4 ",
  disablehandle,
  NoLabel,
  handleError,
  placeholder,
  id,
  IsFormikInput,
  valueTempt,
  handleDispatch,
}) => {
  return (
    <>
      <div className={`${ColSize}`}>
        {!NoLabel && (
          <label className="form-label">
            {InputLabel}
            {requiredStar && <span className="text-danger ml-1"> *</span>}
          </label>
        )}

        <Select
          id={id}
          styles={customStyles}
          name={id}
          placeholder={placeholder || "Select..."}
          className="small-select "
          classNamePrefix="react-select"
          isDisabled={disablehandle || false}
          isMulti={Multiple ? true : false}
          options={[...options]}
          value={Multiple ? valueTempt : options?.find((option) => option.value == valueTempt)}
          onChange={(e) => {
            IsFormikInput ? handleDispatch(e) : handleDispatch(e, id);
          }}
        />
        {handleError && handleError()}
        <br></br>
      </div>
    </>
  );
};

export const CMDropDown = ({
  InputLabel,
  options,
  Multiple,
  requiredStar,
  AvoidFormInputCss,
  disablehandle,
  NoLabel,
  handleError,
  placeholder,
  id,
  ColSize = "col-md-4 ",
  IsFormikInput,
  valueTempt,
  handleDispatch,
  AddLink,
  AddLinkLabel,
  AvoidMarginBottomCss,
}) => {
  return (
    <>
      <div className={`${ColSize}`}>
        {!NoLabel && (
          <label className="form-label">
            {InputLabel}
            {requiredStar && <span className="text-danger ml-1"> *</span>}
          </label>
        )}
        {Multiple ? (
          <MultiSelect
            options={[...options]}
            disabled={disablehandle || false}
            value={valueTempt || []}
            // value={Multiple ? valueTempt :  options?.find((option) => option.value == valueTempt)}
            onChange={(e) => {
              IsFormikInput ? handleDispatch(e) : handleDispatch(e, id);
            }}
            labelledBy="Select"
          />
        ) : (
          <Select
            id={id}
            className={disablehandle ? "" : ""}
            name={id}
            placeholder={placeholder || "Select..."}
            //   placeholder
            isDisabled={disablehandle || false}
            isMulti={Multiple ? true : false}
            options={[...options]}
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            value={Multiple ? valueTempt : options?.find((option) => option.value == valueTempt)}
            onChange={(e) => {
              IsFormikInput ? handleDispatch(e) : handleDispatch(e, id);
            }}
          />
        )}
        {/* {extraDetail && } */}
        {handleError && handleError()}
      </div>
    </>
  );
};

export const DateInput = ({ id, label, index, field, setFieldValue, setFieldError, errors, touched, values, errorMessage, colSize }) => {
  const handleDateChange = (date) => {
    setFieldValue(`Duties[${index}].${id}`, date);

    const startDate = id === "StartDate" ? date : values.Duties[index].StartDate;
    const endDate = id === "EndDate" ? date : values.Duties[index].EndDate;

    if (startDate && endDate) {
      if (moment(startDate).isAfter(moment(endDate))) {
        setFieldError(`Duties[${index}].EndDate`, "End date cannot be before start date");
      } else {
        setFieldError(`Duties[${index}].EndDate`, "");
      }
    }
  };

  return (
    <div className={`${colSize ? colSize : "col-sm-12 col-md-3 mb-n3"}`}>
      <label className="form-label">
        {label} <span className="text-danger ml-1">*</span>
      </label>
      <Flatpickr
        className={`form-control ${field[id] ? "flatpickr-placeholder" : ""}`}
        options={{ dateFormat: "d-m-Y" }}
        placeholder={field[id] ? moment(field[id]).format("DD-MM-YYYY") : "DD-MM-YYYY"}
        value={field[id] || ""}
        onChange={([date]) => handleDateChange(date)}
      />
      {errorMessage && errorMessage(errors, touched, index, id)}
      {/* {touched.Duties?.[index]?.[id] && errors.Duties?.[index]?.[id] && (
        <div className="text-danger">
          <div style={{ fontSize: "0.9em" }} className="text-danger text-left">
            <strong>{errors.Duties[index][id]}</strong>
          </div>
        </div>
      )} */}
    </div>
  );
};

// export const exportToExcel = async (data, fileName = "websites") => {
//   if (!data || data.length === 0) return;

//   const workbook = new ExcelJS.Workbook();
//   const worksheet = workbook.addWorksheet("Websites");

//   const headers = Object.keys(data[0]);
//   const borderColor = "FFCCCCCC"; // Light gray border

//   // Add header row with styles
//   const headerRow = worksheet.addRow(headers);
//   headerRow.eachCell((cell) => {
//     cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
//     cell.alignment = { horizontal: "center", vertical: "middle" };
//     cell.fill = {
//       type: "pattern",
//       pattern: "solid",
//       fgColor: { argb: "FF2F75B5" }, // Blue header background
//     };
//     cell.border = {
//       top: { style: "thin", color: { argb: borderColor } },
//       bottom: { style: "thin", color: { argb: borderColor } },
//       left: { style: "thin", color: { argb: borderColor } },
//       right: { style: "thin", color: { argb: borderColor } },
//     };
//   });

//   // Add data rows with light gray borders
//   data.forEach((item) => {
//     const row = worksheet.addRow(headers.map((h) => item[h]));
//     row.eachCell((cell) => {
//       cell.alignment = { vertical: "middle", horizontal: "left" };
//       cell.border = {
//         top: { style: "thin", color: { argb: borderColor } },
//         bottom: { style: "thin", color: { argb: borderColor } },
//         left: { style: "thin", color: { argb: borderColor } },
//         right: { style: "thin", color: { argb: borderColor } },
//       };
//     });
//   });

//   // Auto-fit column widths
//   worksheet.columns.forEach((col) => {
//     let maxLength = 10;
//     col.eachCell({ includeEmpty: true }, (cell) => {
//       const len = cell.value ? cell.value.toString().length : 0;
//       if (len > maxLength) maxLength = len;
//     });
//     col.width = maxLength + 2;
//   });

//   // Save the file
//   const buffer = await workbook.xlsx.writeBuffer();
//   const blob = new Blob([buffer], {
//     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//   });
//   saveAs(blob, `${fileName}_${new Date().toISOString().slice(0, 10)}.xlsx`);
// };

// export const exportToExcel = async (data, fileName = "websites") => {
//   if (!data || data.length === 0) return;

//   const workbook = new ExcelJS.Workbook();
//   const worksheet = workbook.addWorksheet("Websites");

//   const headers = Object.keys(data[0]);
//   const borderColor = "FFCCCCCC"; // Light gray border
//   const headerBg = "FF2F75B5"; // Blue
//   const zebraLight = "FFF2F2F2"; // Very light gray
//   const zebraDark = "FFFFFFFF"; // White

//   // Add header row
//   const headerRow = worksheet.addRow(headers);

//   // Style header row
//   headerRow.eachCell((cell) => {
//     cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
//     cell.alignment = { horizontal: "center", vertical: "middle" };
//     cell.fill = {
//       type: "pattern",
//       pattern: "solid",
//       fgColor: { argb: headerBg },
//     };
//     cell.border = {
//       top: { style: "thin", color: { argb: borderColor } },
//       bottom: { style: "thin", color: { argb: borderColor } },
//       left: { style: "thin", color: { argb: borderColor } },
//       right: { style: "thin", color: { argb: borderColor } },
//     };
//   });

//   // Freeze header
//   worksheet.views = [{ state: "frozen", ySplit: 1 }];

//   // Add data rows with zebra striping
//   data.forEach((item, rowIndex) => {
//     const row = worksheet.addRow(headers.map((h) => item[h]));

//     row.eachCell((cell, colNumber) => {
//       // Zebra striping
//       cell.fill = {
//         type: "pattern",
//         pattern: "solid",
//         fgColor: {
//           argb: rowIndex % 2 === 0 ? zebraLight : zebraDark,
//         },
//       };

//       // Borders
//       cell.border = {
//         top: { style: "thin", color: { argb: borderColor } },
//         bottom: { style: "thin", color: { argb: borderColor } },
//         left: { style: "thin", color: { argb: borderColor } },
//         right: { style: "thin", color: { argb: borderColor } },
//       };

//       // Alignment based on data type
//       const value = cell.value;
//       if (typeof value === "number") {
//         cell.alignment = { horizontal: "right", vertical: "middle" };
//       } else if (value instanceof Date) {
//         cell.alignment = { horizontal: "center", vertical: "middle" };
//       } else {
//         cell.alignment = { horizontal: "left", vertical: "middle" };
//       }
//     });
//   });

//   // Auto-fit column widths
//   worksheet.columns.forEach((col) => {
//     let maxLength = 10;
//     col.eachCell({ includeEmpty: true }, (cell) => {
//       const len = cell.value ? cell.value.toString().length : 0;
//       if (len > maxLength) maxLength = len;
//     });
//     col.width = maxLength + 4; // More breathing room
//   });

//   // Enable AutoFilter on headers
//   worksheet.autoFilter = {
//     from: { row: 1, column: 1 },
//     to: { row: 1, column: headers.length },
//   };

//   // Save the file
//   const buffer = await workbook.xlsx.writeBuffer();
//   const blob = new Blob([buffer], {
//     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//   });
//   saveAs(blob, `${fileName}_${new Date().toISOString().slice(0, 10)}.xlsx`);
// };

// export const exportToExcel = async (data, fileName = "websites") => {
//   if (!data || data.length === 0) return;

//   const workbook = new ExcelJS.Workbook();
//   const worksheet = workbook.addWorksheet("Websites");

//   const headers = Object.keys(data[0]);
//   const borderColor = "FFCCCCCC"; // Light gray border
//   const headerBg = "FF2F75B5"; // Blue
//   const zebraLight = "FFF2F2F2"; // Very light gray
//   const zebraDark = "FFFFFFFF"; // White

//   // Add header row
//   const headerRow = worksheet.addRow(headers);

//   // Style header row
//   headerRow.eachCell((cell) => {
//     cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
//     cell.alignment = { horizontal: "center", vertical: "middle" };
//     cell.fill = {
//       type: "pattern",
//       pattern: "solid",
//       fgColor: { argb: headerBg },
//     };
//     cell.border = {
//       top: { style: "thin", color: { argb: borderColor } },
//       bottom: { style: "thin", color: { argb: borderColor } },
//       left: { style: "thin", color: { argb: borderColor } },
//       right: { style: "thin", color: { argb: borderColor } },
//     };
//   });

//   // Freeze header
//   worksheet.views = [{ state: "frozen", ySplit: 1 }];

//   // Add data rows with zebra striping
//   data.forEach((item, rowIndex) => {
//     const row = worksheet.addRow(headers.map((h) => item[h]));

//     row.eachCell((cell, colNumber) => {
//       // Zebra striping
//       cell.fill = {
//         type: "pattern",
//         pattern: "solid",
//         fgColor: {
//           argb: rowIndex % 2 === 0 ? zebraLight : zebraDark,
//         },
//       };

//       // Borders
//       cell.border = {
//         top: { style: "thin", color: { argb: borderColor } },
//         bottom: { style: "thin", color: { argb: borderColor } },
//         left: { style: "thin", color: { argb: borderColor } },
//         right: { style: "thin", color: { argb: borderColor } },
//       };

//       // Alignment based on data type
//       //   const value = cell.value;
//       //   if (typeof value === "number") {
//       //     cell.alignment = { horizontal: "right", vertical: "middle", wrapText: true };
//       //   } else if (value instanceof Date) {
//       //     cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
//       //   } else {
//       //     cell.alignment = { horizontal: "left", vertical: "middle", wrapText: true };
//       //   }
//       // });
//       // row.height = undefined;

//       cell.alignment = {
//         wrapText: true,
//         vertical: "middle",
//         horizontal: typeof cell.value === "number" ? "right" : cell.value instanceof Date ? "center" : "left",
//       };
//     });

//     // Let Excel auto-adjust row height
//     row.height = undefined;
//   });

//   worksheet.columns.forEach((col) => {
//     let maxLength = 40; // max characters per line before wrapping
//     col.width = Math.min(maxLength, 40); // cap column width
//   });
//   // Auto-fit column widths
//   // worksheet.columns.forEach((col) => {
//   //   let maxLength = 10;
//   //   col.eachCell({ includeEmpty: true }, (cell) => {
//   //     const len = cell.value ? cell.value.toString().length : 0;
//   //     if (len > maxLength) maxLength = len;
//   //   });
//   //   col.width = maxLength + 4; // More breathing room
//   // });

//   // Enable AutoFilter on headers
//   worksheet.autoFilter = {
//     from: { row: 1, column: 1 },
//     to: { row: 1, column: headers.length },
//   };

//   // Save the file
//   const buffer = await workbook.xlsx.writeBuffer();
//   const blob = new Blob([buffer], {
//     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//   });
//   saveAs(blob, `${fileName}_${new Date().toISOString().slice(0, 10)}.xlsx`);
// };

// export const exportToExcel = async (data, fileName = "Member_List") => {
//   if (!data || data.length === 0) return;

//   const workbook = new ExcelJS.Workbook();
//   const worksheet = workbook.addWorksheet("Members");

//   const headers = Object.keys(data[0]).filter((h) => h !== "_memberLength"); // exclude helper field
//   const borderColor = "FFCCCCCC";
//   const headerBg = "FF2F75B5"; // Blue
//   const zebraLight = "FFF2F2F2"; // Light gray
//   const zebraDark = "FFFFFFFF"; // White

//   // Add header row
//   const headerRow = worksheet.addRow(headers);

//   headerRow.eachCell((cell) => {
//     cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
//     cell.alignment = { horizontal: "center", vertical: "middle" };
//     cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: headerBg } };
//     cell.border = {
//       top: { style: "thin", color: { argb: borderColor } },
//       bottom: { style: "thin", color: { argb: borderColor } },
//       left: { style: "thin", color: { argb: borderColor } },
//       right: { style: "thin", color: { argb: borderColor } },
//     };
//   });

//   worksheet.views = [{ state: "frozen", ySplit: 1 }];

//   let currentRowIndex = 2; // Start after header
//   let colorToggle = true; // For alternating colors per head

//   for (let i = 0; i < data.length; ) {
//     const headData = data[i];
//     const memberCount = headData._memberLength || 1;
//     const startRow = currentRowIndex;
//     const endRow = startRow + memberCount - 1;

//     // Pick color for this head
//     const headColor = colorToggle ? zebraLight : zebraDark;
//     colorToggle = !colorToggle; // alternate for next head

//     // Add rows for each member
//     for (let j = 0; j < memberCount; j++) {
//       const rowData = data[i + j];
//       const row = worksheet.addRow(headers.map((h) => rowData[h] || ""));

//       row.eachCell((cell) => {
//         cell.alignment = {
//           wrapText: true,
//           vertical: "middle",
//           horizontal:
//             typeof cell.value === "number"
//               ? "right"
//               : cell.value instanceof Date
//               ? "center"
//               : "left",
//         };
//         cell.border = {
//           top: { style: "thin", color: { argb: borderColor } },
//           bottom: { style: "thin", color: { argb: borderColor } },
//           left: { style: "thin", color: { argb: borderColor } },
//           right: { style: "thin", color: { argb: borderColor } },
//         };
//         cell.fill = {
//           type: "pattern",
//           pattern: "solid",
//           fgColor: { argb: headColor },
//         };
//       });

//       row.height = undefined;
//       currentRowIndex++;
//     }

//     // Merge Sr No, Head Name, Village, Locality
//     ["Sr No", "Head Name", "Village", "Locality"].forEach((colName) => {
//       const colIndex = headers.indexOf(colName) + 1;
//       if (startRow !== endRow) {
//         worksheet.mergeCells(startRow, colIndex, endRow, colIndex);
//       }
//     });

//     i += memberCount; // move to next head
//   }

//   // Set column widths
//   worksheet.columns.forEach((col) => {
//     if (col.header === "Sr No") {
//       col.width = 5;
//     } else {
//       let maxLength = 10;
//       col.eachCell({ includeEmpty: true }, (cell) => {
//         const len = cell.value ? cell.value.toString().length : 0;
//         if (len > maxLength) maxLength = len;
//       });
//       col.width = Math.min(maxLength + 2, 50);
//     }
//   });

//   // Enable AutoFilter
//   worksheet.autoFilter = {
//     from: { row: 1, column: 1 },
//     to: { row: 1, column: headers.length },
//   };

//   // Save file
//   const buffer = await workbook.xlsx.writeBuffer();
//   const blob = new Blob([buffer], {
//     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//   });
//   saveAs(blob, `${fileName}_${new Date().toISOString().slice(0, 10)}.xlsx`);
// };

export const exportToExcel = async (data, fileName = "Member_List", options = {}, bhajanMandaliType) => {
  if (!data?.length) return;

  const { columnVertPadding = {} } = options; // <-- NEW

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Members");

  const headers = Object.keys(data[0]).filter((h) => h !== "_memberLength");

  const totalColumns = headers.length;
  if (bhajanMandaliType) {
    const titleRow = worksheet.addRow([`${bhajanMandaliType}`]);
    worksheet.mergeCells(1, 1, 1, totalColumns);
    titleRow.height = 30;
    titleRow.getCell(1).font = { bold: true, size: 18, color: { argb: "FF2F75B5" } };
    titleRow.getCell(1).alignment = { horizontal: "center", vertical: "middle" };
  }
  const borderColor = "FFCCCCCC";
  const headerBg = "FF2F75B5";
  const zebraLight = "FFF2F2F2";
  const zebraDark = "FFFFFFFF";

  // ---------- HEADER ----------
  const headerRow = worksheet.addRow(headers);
  let headerHeight = 22; // default
  headerRow.eachCell((cell, colNumber) => {
    const colName = headers[colNumber - 1];
    const pad = columnVertPadding[colName] ?? 0;

    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.alignment = {
      horizontal: "center",
      vertical: "middle",
      wrapText: true,
      // NO indent → no left/right padding
    };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: headerBg } };
    cell.border = {
      top: { style: "thin", color: { argb: borderColor } },
      bottom: { style: "thin", color: { argb: borderColor } },
      left: { style: "thin", color: { argb: borderColor } },
      right: { style: "thin", color: { argb: borderColor } },
    };

    if (pad > 0) {
      headerHeight = Math.max(headerHeight, 15 + pad * 2);
    }
  });
  headerRow.height = headerHeight;

  worksheet.views = [{ state: "frozen", ySplit: 1 }];

  let rowIdx = 2;
  let zebra = true;

  // ---------- DATA ----------
  for (let i = 0; i < data.length; ) {
    const head = data[i];
    const count = head._memberLength || 1;
    const startRow = rowIdx;
    const endRow = startRow + count - 1;
    const bgColor = zebra ? zebraLight : zebraDark;
    zebra = !zebra;

    // Step 1: First pass – collect max padding & estimate text height
    const rowHeights = Array(count).fill(0); // per-row min height
    const colMaxPad = new Map(); // per-column max padding in group

    for (let j = 0; j < count; j++) {
      const rowData = data[i + j];
      const values = headers.map((h) => rowData[h] ?? "");

      values.forEach((val, idx) => {
        const colName = headers[idx];
        const pad = columnVertPadding[colName] ?? 0;
        if (pad > 0) colMaxPad.set(colName, Math.max(colMaxPad.get(colName) || 0, pad));

        // Estimate lines (for wrapText)
        const lines = String(val).split("\n").length;
        const minHeight = Math.max(15, lines * 15); // 15pt per line
        rowHeights[j] = Math.max(rowHeights[j], minHeight);
      });
    }

    // Step 2: Compute final height per row (max of all influences)
    const finalRowHeights = rowHeights.map((base, j) => {
      let maxInRow = base;

      // Add padding from any column in this row
      headers.forEach((colName) => {
        const pad = columnVertPadding[colName] ?? 0;
        if (pad > 0) {
          maxInRow = Math.max(maxInRow, 15 + pad * 2);
        }
      });

      return maxInRow;
    });

    // Step 3: Apply rows with correct height
    for (let j = 0; j < count; j++) {
      const rowData = data[i + j];
      const row = worksheet.addRow(headers.map((h) => rowData[h] ?? ""));

      row.height = finalRowHeights[j]; // <-- final height

      row.eachCell((cell, colNumber) => {
        const colName = headers[colNumber - 1];

        cell.alignment = {
          wrapText: true,
          vertical: "middle",
          horizontal: typeof cell.value === "number" ? "right" : cell.value instanceof Date ? "center" : "left",
          // NO indent
        };
        cell.border = {
          top: { style: "thin", color: { argb: borderColor } },
          bottom: { style: "thin", color: { argb: borderColor } },
          left: { style: "thin", color: { argb: borderColor } },
          right: { style: "thin", color: { argb: borderColor } },
        };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
      });

      rowIdx++;
    }

    // ---- MERGE (Sr No, Name, etc.) ----
    ["Sr No", "Head Name", "Village", "Locality"].forEach((colName) => {
      const col = headers.indexOf(colName) + 1;
      if (startRow !== endRow) {
        worksheet.mergeCells(startRow, col, endRow, col);
        const merged = worksheet.getCell(startRow, col);
        merged.alignment = { vertical: "middle", horizontal: "left", wrapText: true };
      }
    });

    i += count;
  }

  // ---------- COLUMN WIDTH ----------
  worksheet.columns.forEach((col) => {
    const name = col.header;
    if (name === "Sr No") {
      col.width = 6;
      return;
    }
    let max = 10;
    col.eachCell({ includeEmpty: true }, (c) => {
      const len = c.value ? String(c.value).length : 0;
      if (len > max) max = len;
    });
    col.width = Math.min(max + 3, 60);
  });

  // ---------- AUTOFILTER ----------
  worksheet.autoFilter = {
    from: { row: bhajanMandaliType ? 2 : 1, column: 1 },
    to: { row: bhajanMandaliType ? 2 : 1, column: headers.length },
  };

  // ---------- SAVE ----------
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `${fileName}_${new Date().toISOString().slice(0, 10)}.xlsx`);
};

export const exportYojanaToExcel = async (data, fileName = "Yojana_Report") => {
  if (!data?.length) return;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Yojana Report", {
    pageSetup: {
      paperSize: 9,
      orientation: "portrait",
      fitToPage: true,
      fitToWidth: 1,
    },
  });

  const blueHeader = "FF2F75B5";
  const borderColor = "FFCCCCCC";
  const lightBg = "FFF8FAFC";

  data.forEach((rowData, idx) => {
    const row = worksheet.addRow([rowData.A, rowData.B, rowData.C, rowData.D]);

    // -------- Header Row 1: Village Name --------
    if (idx === 0) {
      worksheet.mergeCells(`A${row.number}:D${row.number}`);
      const cell = worksheet.getCell(`A${row.number}`);
      cell.font = { size: 12, bold: true, color: { argb: "FF1E40AF" } };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      row.height = 25;
      return;
    }

    // -------- Header Row 2: Beneficiary Summary --------
    if (idx === 1) {
      worksheet.mergeCells(`A${row.number}:D${row.number}`);
      const cell = worksheet.getCell(`A${row.number}`);
      cell.font = { size: 12, bold: true, color: { argb: "FF1E40AF" } };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      row.height = 25;
      return;
    }

    // -------- Header Row 3: Table Columns --------
    if (idx === 2) {
      row.eachCell((cell) => {
        cell.font = { bold: true, size: 12, color: { argb: "FFFFFFFF" } };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: blueHeader } };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = {
          top: { style: "medium", color: { argb: borderColor } },
          bottom: { style: "medium", color: { argb: borderColor } },
          left: { style: "medium", color: { argb: borderColor } },
          right: { style: "medium", color: { argb: borderColor } },
        };
      });
      row.height = 25;
      return;
    }

    // -------- DATA ROWS --------
    const isEven = (idx - 2) % 2 === 0;

    row.eachCell((cell, colNum) => {
      cell.alignment = { vertical: "middle", horizontal: colNum == 1 ? "left" : "center", wrapText: true, indent: colNum === 1 ? 1 : 0 };

      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: isEven ? lightBg : "FFFFFFFF" },
      };

      cell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      };
    });

    row.height = 25;
  });

  // -------- Column Widths --------
  worksheet.columns = [
    { width: 50 }, // યોજનાનું નામ
    { width: 30 }, // લાભાર્થીઓ
    { width: 45 }, // રકમ
    { width: 18 }, // સમયગાળો
  ];

  worksheet.views = [{ state: "normal", ySplit: 3 }];

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, `${fileName}_${new Date().toISOString().slice(0, 10)}.xlsx`);
};

export const exportVillageToExcel = async (data, fileName = "ગામ રિપોર્ટ") => {
  if (!data?.length) return;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("ગામ રિપોર્ટ", {
    pageSetup: { paperSize: 9, orientation: "portrait", fitToPage: true, fitToWidth: 1 },
  });

  const blueHeader = "FF2F75B5";
  const lightBg = "FFF8FAFC";

  // Detect if Amount column exists
  const hasAmountCol = data.slice(3).some((row) => row.Amount != null);
  const totalColumns = hasAmountCol ? 5 : 4;

  // Last column letter (e.g., "D" for 4 columns)
  const lastColLetter = String.fromCharCode(65 + totalColumns - 1); // A=1 → D=4

  data.forEach((rowData, idx) => {
    let values = [];

    if (idx === 0) {
      // Row 1: Title (Yojana Name) → in Gujarati
      values = [rowData["Village Name"] || "ગામ યોજના રિપોર્ટ"];
    } else if (idx === 1) {
      // Row 2: Summary → Full Gujarati
      const enSummary = rowData["Village Name"] || "";
      let guSummary = enSummary
        .replace("Total:", "કુલ:")
        .replace("Used:", "વપરાયેલ:")
        .replace("Not Used:", "ન વપરાયેલ:")
        .replace("Not Used Yojana Villages", "વપરાશ ન થયેલ યોજના ગામો")
        .replace("Used Yojana Villages", "વપરાયેલ યોજના ગામો");

      values = [guSummary];
    } else if (idx === 2) {
      // Row 3: Gujarati Headers
      values = hasAmountCol
        ? ["ગામનું નામ", "કુલ મતદારો", "લાભાર્થીઓની સંખ્યા", "કુલ લાભાર્થી લાભ", "રકમ (₹)"]
        : ["ગામનું નામ", "કુલ મતદારો", "લાભાર્થીઓની સંખ્યા", "કુલ લાભાર્થી લાભ"];
    } else {
      // Data rows
      values = hasAmountCol
        ? [rowData["Village Name"] || "", rowData.Voters || "0", rowData.Labharthi || "0", rowData.LabharthiLabh || "0", rowData.Amount || ""]
        : [rowData["Village Name"] || "", rowData.Voters || "0", rowData.Labharthi || "0", rowData.LabharthiLabh || "0"];
    }

    const row = worksheet.addRow(values);

    // ────────────────────── STYLING ──────────────────────
    if (idx === 0 || idx === 1) {
      // Title & Subtitle → Merge EXACTLY to last column of table
      const mergeRange = `A${row.number}:${lastColLetter}${row.number}`;
      worksheet.mergeCells(mergeRange);
      const mergedCell = worksheet.getCell(`A${row.number}`);

      mergedCell.font = {
        size: idx === 0 ? 13 : 13,
        bold: true,
        color: { argb: "FF1E40AF" },
      };
      mergedCell.alignment = { horizontal: "center", vertical: "middle" };
      row.height = idx === 0 ? 25 : 25;
    } else if (idx === 2) {
      // Header Row
      row.eachCell((cell) => {
        cell.font = { bold: true, size: 12, color: { argb: "FFFFFFFF" } };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: blueHeader } };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = { top: { style: "medium" }, bottom: { style: "medium" }, left: { style: "medium" }, right: { style: "medium" } };
      });
      row.height = 25;
    } else {
      // Data Rows
      const isEven = (idx - 2) % 2 === 0;
      row.eachCell((cell, colNum) => {
        cell.alignment = { vertical: "middle", horizontal: "center" };

        if (colNum === 3) {
          const num = parseInt((cell.value || "0").replace(/,/g, ""), 10);
          cell.font = { bold: true, color: num > 0 ? { argb: "FF006400" } : { argb: "FF64748B" } };
        }
        if (colNum === 4) {
          const num = parseInt((cell.value || "0").replace(/,/g, ""), 10);
          cell.font = { bold: true, color: num > 0 ? { argb: "FF006400" } : { argb: "FF64748B" } };
        }
        if (colNum === 5 && hasAmountCol) {
          cell.font = { bold: true, color: { argb: "FF16A34A" } };
        }

        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: isEven ? lightBg : "FFFFFFFF" },
        };
        cell.border = { top: { style: "thin" }, bottom: { style: "thin" }, left: { style: "thin" }, right: { style: "thin" } };
      });
      row.height = 25;
    }
  });

  // Column Widths (optimized for Gujarati)
  worksheet.columns = hasAmountCol ? [{ width: 48 }, { width: 18 }, { width: 27 }, { width: 27 }, { width: 25 }] : [{ width: 52 }, { width: 20 }, { width: 27 }, { width: 27 }];

  // Header & Footer in Gujarati
  worksheet.headerFooter.firstHeader = `&L&14&B${fileName}`;
  worksheet.headerFooter.firstFooter = `&Cપેજ &P / &N`;

  // Save
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `${fileName}_${new Date().toISOString().slice(0, 10)}.xlsx`);
};

export const exportVillageToPDF = (data, fileName = "Village_Report") => {
  if (!data?.length) {
    toast.error("No data to export");
    return;
  }

  const doc = new jsPDF("p", "mm", "a4");
  addGujaratiFont(doc); // ← Same as your working exportVillagesToPDF

  const yojanaName = data[0]["Village Name"] || "Village Report";
  const tabTitle = data[1]["Village Name"] || "All Yojana Villages";
  // const summary    = data[2]["Village Name"] || "";

  // Title & Subtitle — same compact style as your working one
  autoTable(doc, {
    body: [[yojanaName]],
    theme: "plain",
    styles: { fontSize: 18, fontStyle: "bold", textColor: [30, 64, 175], halign: "center" },
    margin: { top: 15 },
  });

  autoTable(doc, {
    body: [[tabTitle]],
    theme: "plain",
    styles: { fontSize: 14, halign: "center", textColor: [30, 64, 175] },
    margin: { top: 5 },
  });

  // autoTable(doc, {
  //   body: [[summary]],
  //   theme: "plain",
  //   styles: { fontSize: 11, halign: "center", textColor: [71, 85, 105] },
  //   margin: { top: 5 }
  // });

  const hasAmountCol = data.slice(4).some((row) => row.Amount && row.Amount !== "-");

  // Clean numeric data — same trick that works in your other exports
  const tableData = data.slice(4).map((row, i) => {
    const base = [
      (i + 1).toString(),
      row["Village Name"] || "-",
      row["Voters"] ? Number(row["Voters"].replace(/,/g, "")) : 0,
      row["Labharthi"] ? Number(row["Labharthi"].replace(/,/g, "")) : 0,
    ];
    if (hasAmountCol) {
      base.push(row.Amount || "");
    }
    return base;
  });

  const head = hasAmountCol ? [["No", "Village Name", "Voters", "Labharthi", "Amount"]] : [["No", "Village Name", "Voters", "Labharthi"]];

  autoTable(doc, {
    head: [head[0]],
    body: tableData,
    startY: doc.lastAutoTable.finalY + 10,
    theme: "grid",
    margin: { left: 12, right: 12 },

    headStyles: {
      fillColor: [47, 117, 181],
      textColor: [255, 255, 255],
      fontStyle: "bold",
      fontSize: 12,
      halign: "center",
      cellPadding: 6,
    },

    bodyStyles: {
      font: "NotoSansGujarati",
      fontSize: 11,
      cellPadding: 5,
      halign: "center",
    },

    // columnStyles: hasAmountCol ? {
    //   0: { cellWidth: 18 },
    //   1: { cellWidth: 80, halign: "left", cellPadding: { left: 8 } },
    //   2: { cellWidth: 32 },
    //   3: { cellWidth: 32 },
    //   4: { cellWidth: 38, halign: "right", cellPadding: { right: 8 } }
    // } : {
    //   0: { cellWidth: 20 },
    //   1: { cellWidth: 95, halign: "left", cellPadding: { left: 8 } },
    //   2: { cellWidth: 45 },
    //   3: { cellWidth: 45 }
    // },

    alternateRowStyles: { fillColor: [248, 250, 252] },

    // SAME MAGIC as your working exportVillagesToPDF
    didDrawCell: (data) => {
      doc.setFont("NotoSansGujarati");

      if (data.section === "body") {
        const value = Number(data.cell.raw);

        // Format Voters & Labharthi
        if (data.column.index === 2 || data.column.index === 3) {
          data.cell.text = [value > 0 ? value.toLocaleString("en-IN") : "0"];
          if (data.column.index === 3) {
            // doc.setTextColor(value > 0 ? [0, 128, 0] : [100, 116, 139]);
            doc.setFont("NotoSansGujarati", value > 0 ? "bold" : "normal");
          }
        }

        // Format Amount
        if (hasAmountCol && data.column.index === 4) {
          data.cell.text = [value > 0 ? `₹${value.toLocaleString("en-IN")}` : "-"];
          // doc.setTextColor(value > 0 ? [22, 163, 74] : [100, 116, 139]);
          doc.setFont("NotoSansGujarati", value > 0 ? "bold" : "normal");
        }
      }
    },
  });

  // Footer — same as your working one
  const pageHeight = doc.internal.pageSize.height;
  doc.setFont("NotoSansGujarati");
  doc.setFontSize(9);
  doc.setTextColor(100);
  doc.text(`જનરેટ તારીખ: ${new Date().toLocaleDateString("gu-IN")}`, 105, pageHeight - 10, { align: "center" });

  doc.save(`${fileName}_${new Date().toISOString().slice(0, 10)}.pdf`);
  // toast.success("PDF ડાઉનલોડ થયું!");
};

export const exportVillageYojanaToPDF = (data, fileName = "Yojana_Report") => {
  if (!data?.length) {
    toast.error("No data to export");
    return;
  }

  const doc = new jsPDF("p", "mm", "a4");
  addGujaratiFont(doc);

  const villageName = data[0]["Yojana Name"].replace("Village: ", "");
  const totalLabharthi = data[1]["Yojana Name"];

  // Title & Subtitle
  doc.setFont("NotoSansGujarati", "bold");
  doc.setFontSize(16);
  doc.setTextColor(30, 64, 175);
  doc.text(`Village: ${villageName}`, 105, 20, { align: "center" });

  doc.setFontSize(14);
  doc.text(totalLabharthi, 105, 30, { align: "center" });

  // Table body — plain strings only (no ₹ or fancy objects)
  const tableBody = data.slice(4).map((row) => {
    const amountRaw = (row.Amount || "-").replace(/₹/g, "₹"); // keep ₹ symbol
    return [
      row["Yojana Name"] || "-",
      amountRaw, // pure string with \n
    ];
  });

  autoTable(doc, {
    head: [["Yojana Name", "Amount"]],
    body: tableBody,
    startY: 42,
    theme: "grid",
    margin: { left: 15, right: 15 },

    headStyles: {
      fillColor: [47, 117, 181],
      textColor: [255, 255, 255],
      fontStyle: "bold",
      fontSize: 13,
      halign: "center",
      valign: "middle",
      cellPadding: 10,
    },

    bodyStyles: {
      font: "NotoSansGujarati",
      fontSize: 11,
      cellPadding: { top: 3, bottom: 3, left: 8, right: 8 },
      halign: "center",
      valign: "middle",
      lineWidth: 0.3,
      lineColor: [204, 204, 204],
      minCellHeight: 15,
    },

    columnStyles: {
      0: { halign: "center" },
      1: { halign: "center" },
    },

    alternateRowStyles: { fillColor: [248, 250, 252] },

    // THE MAGIC FIX — apply styling manually
    didDrawCell: (data) => {
      if (data.section === "body" && data.column.index === 1) {
        const text = data.cell.text.join(" ");
        const hasCalculation = text.includes("×") || text.includes("=");
        const isZero = text.includes("Labharthi : 0") || text === "-";

        doc.setFont("NotoSansGujarati", hasCalculation ? "bold" : "normal");
        doc.setFontSize(hasCalculation ? 11.5 : 11);
        doc.setTextColor(...(hasCalculation ? [0, 100, 0] : isZero ? [100, 116, 139] : [0, 0, 0]));
      } else {
        doc.setFont("NotoSansGujarati");
      }
    },
  });

  // Footer
  const pageHeight = doc.internal.pageSize.height;
  doc.setFont("NotoSansGujarati");
  doc.setFontSize(9);
  doc.setTextColor(100);
  doc.text(`જનરેટ તારીખ: ${new Date().toLocaleDateString("gu-IN")}`, 105, pageHeight - 12, { align: "center" });

  doc.save(`${fileName}_${new Date().toISOString().slice(0, 10)}.pdf`);
  // toast.success("PDF ડાઉનલોડ થયું!");
};
export const exportBenifeciaryExcel = async (data, fileName = "Member_List", options = {}) => {
  if (!data?.length) return;

  const { selYojna, selVillage, tab } = options; // <-- New: Pass from handleExport
  const { columnVertPadding = {} } = options;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Members");

  const headers = Object.keys(data[0]).filter((h) => h !== "_memberLength");
  const borderColor = "FFCCCCCC";
  const headerBg = "FF2F75B5";

  // === 1. Yojana Name (Big Title) ===
  if (tab == "overall") {
    const titleRow = worksheet.addRow([selYojna?.GramYojnaName]);
    worksheet.mergeCells(`A${titleRow.number}:E${titleRow.number}`);
    const titleCell = worksheet.getCell(`A${titleRow.number}`);
    titleCell.font = { size: 12, bold: true, color: { argb: "FF1E40AF" } };
    titleCell.alignment = { horizontal: "center", vertical: "middle" };
    titleRow.height = 25;

    const titleRow2 = worksheet.addRow([
      `ગામનું નામ: ${selVillage?.VillageNameEnglish} | લાભાર્થીઓ :  ${selVillage?.BeneficialCount?.toLocaleString()}  ${
        selVillage?.TotalAmount ? `| વિતરણ થયેલી રકમ : ₹${selVillage?.TotalAmount?.toLocaleString()}` : ""
      } | મતદારો : ${selVillage?.VillageVoterCount?.toLocaleString()}`,
    ]);
    worksheet.mergeCells(`A${titleRow2.number}:E${titleRow2.number}`);
    const titleCell2 = worksheet.getCell(`A${titleRow2.number}`);
    titleCell2.font = { size: 12, bold: true, color: { argb: "FF1E40AF" } };
    titleCell2.alignment = { horizontal: "center", vertical: "middle" };
    titleRow2.height = 25;
  }

  // === 2. Village Name ===
  if (tab == "village") {
    const villageRow = worksheet.addRow([selVillage?.VillageNameEnglish]);
    worksheet.mergeCells(`A${villageRow.number}:E${villageRow.number}`);
    const villageCell = worksheet.getCell(`A${villageRow.number}`);
    villageCell.font = { size: 12, bold: true, color: { argb: "FF1E40AF" } };
    villageCell.alignment = { horizontal: "center", vertical: "middle" };
    villageRow.height = 25;

    const villageRow2 = worksheet.addRow([
      `યોજનાનું નામ: ${selYojna?.GramYojnaName} | લાભાર્થીઓ :  ${selYojna?.BeneficialCount?.toLocaleString()} | વિતરણ થયેલી રકમ : ${selYojna?.TotalAmount?.toLocaleString()} `,
    ]);
    worksheet.mergeCells(`A${villageRow2.number}:E${villageRow2.number}`);
    const villageCell2 = worksheet.getCell(`A${villageRow2.number}`);
    villageCell2.font = { size: 12, bold: true, color: { argb: "FF1E40AF" } };
    villageCell2.alignment = { horizontal: "center", vertical: "middle" };
    villageRow2.height = 25;
  }

  // === 3. Empty Row (Spacing) ===
  // if (yojnaName || GramYojnaName) {
  //   worksheet.addRow([]).height = 20;
  // }

  // === 4. Table Header ===
  const headerRow = worksheet.addRow(headers);
  let headerHeight = 25;
  headerRow.eachCell((cell, colNumber) => {
    const colName = headers[colNumber - 1];
    const pad = columnVertPadding[colName] ?? 0;

    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: headerBg } };
    cell.border = {
      top: { style: "medium", color: { argb: borderColor } },
      bottom: { style: "medium", color: { argb: borderColor } },
      left: { style: "medium", color: { argb: borderColor } },
      right: { style: "medium", color: { argb: borderColor } },
    };

    if (pad > 0) headerHeight = Math.max(headerHeight, 15 + pad * 2);
  });
  headerRow.height = headerHeight;

  // Freeze after header
  const headerRowNumber = selYojna?.yojnaName ? (selVillage.GramYojnaName ? 5 : 4) : selVillage?.GramYojnaName ? 3 : 1;
  worksheet.views = [{ state: "normal", ySplit: headerRowNumber }];

  // === 5. Data Rows (Your Original Logic - 100% Preserved) ===
  let rowIdx = headerRowNumber + 1;
  let zebra = true;

  for (let i = 0; i < data.length; ) {
    const head = data[i];
    const count = head._memberLength || 1;
    const startRow = rowIdx;
    const endRow = startRow + count - 1;
    const bgColor = zebra ? "FFF2F2F2" : "FFFFFFFF";
    zebra = !zebra;

    const rowHeights = Array(count).fill(0);
    for (let j = 0; j < count; j++) {
      const rowData = data[i + j];
      const values = headers.map((h) => rowData[h] ?? "");
      values.forEach((val, idx) => {
        const lines = String(val).split("\n").length;
        rowHeights[j] = Math.max(rowHeights[j], Math.max(15, lines * 15));
      });
    }

    for (let j = 0; j < count; j++) {
      const rowData = data[i + j];
      const row = worksheet.addRow(headers.map((h) => rowData[h] ?? ""));
      row.height = rowHeights[j];

      row.eachCell((cell, colNumber) => {
        const colName = headers[colNumber - 1];
        cell.alignment = {
          wrapText: true,
          vertical: "middle",
          horizontal: typeof cell.value === "number" ? "center" : "center",
        };
        cell.border = {
          top: { style: "thin", color: { argb: borderColor } },
          bottom: { style: "thin", color: { argb: borderColor } },
          left: { style: "thin", color: { argb: borderColor } },
          right: { style: "thin", color: { argb: borderColor } },
        };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
      });
      rowIdx++;
    }

    // Merge logic (your original)
    ["Sr No", "Head Name", "Village", "Locality"].forEach((colName) => {
      const col = headers.indexOf(colName) + 1;
      if (startRow !== endRow && col <= headers.length) {
        worksheet.mergeCells(startRow, col, endRow, col);
        worksheet.getCell(startRow, col).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      }
    });

    i += count;
  }

  // === 6. Column Widths (Auto + Max Limit) ===
  // worksheet.columns.forEach(col => {
  //   const name = col.header;
  //   if (name === "Sr No") {
  //     col.width = 7;
  //     return;
  //   }
  //   let max = 12;
  //   col.eachCell({ includeEmpty: true }, c => {
  //     const len = c.value ? String(c.value).length : 0;
  //     if (len > max) max = len;
  //   });
  //   col.width = Math.min(max + 4, 50);
  // });
  worksheet.columns = [{ width: 10 }, { width: 50 }, { width: 30 }, { width: 30 }, { width: 40 }];

  // === 7. AutoFilter ===
  // worksheet.autoFilter = {
  //   from: { row: headerRowNumber, column: 1 },
  //   to: { row: headerRowNumber, column: headers.length },
  // };

  // === 8. Save ===
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `${fileName}_${new Date().toISOString().slice(0, 10)}.xlsx`);
};
export const exportGrantDetailsExcel = async (data, fileName = "Grand_Details", options = {}) => {
  debugger;
  if (!data?.length) return;

  const { selYojna, selVillage, tab } = options; // <-- New: Pass from handleExport
  const { columnVertPadding = {} } = options;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Members");

  const headers = Object.keys(data[0]).filter((h) => h !== "_memberLength");
  const borderColor = "FFCCCCCC";
  const headerBg = "FF2F75B5";

  // === 1. Yojana Name (Big Title) ===
  const titleRow = worksheet.addRow([selYojna?.GrantYojnaName]);
  worksheet.mergeCells(`A${titleRow.number}:F${titleRow.number}`);
  const titleCell = worksheet.getCell(`A${titleRow.number}`);
  titleCell.font = { size: 12, bold: true, color: { argb: "FF1E40AF" } };
  titleCell.alignment = { horizontal: "center", vertical: "middle" };
  titleRow.height = 25;

  const titleRow2 = worksheet.addRow([`ગામનું નામ: ${selVillage?.Village} |  ગ્રાન્ટ વિગતો ગણતરીઓ : ${selVillage?.GrantDetailCount?.toLocaleString()}`]);
  worksheet.mergeCells(`A${titleRow2.number}:F${titleRow2.number}`);
  const titleCell2 = worksheet.getCell(`A${titleRow2.number}`);
  titleCell2.font = { size: 12, bold: true, color: { argb: "FF1E40AF" } };
  titleCell2.alignment = { horizontal: "center", vertical: "middle" };
  titleRow2.height = 25;

  // === 3. Empty Row (Spacing) ===
  // if (yojnaName || GramYojnaName) {
  //   worksheet.addRow([]).height = 20;
  // }

  // === 4. Table Header ===
  const headerRow = worksheet.addRow(headers);
  let headerHeight = 25;
  headerRow.eachCell((cell, colNumber) => {
    const colName = headers[colNumber - 1];
    const pad = columnVertPadding[colName] ?? 0;

    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: headerBg } };
    cell.border = {
      top: { style: "medium", color: { argb: borderColor } },
      bottom: { style: "medium", color: { argb: borderColor } },
      left: { style: "medium", color: { argb: borderColor } },
      right: { style: "medium", color: { argb: borderColor } },
    };

    if (pad > 0) headerHeight = Math.max(headerHeight, 15 + pad * 2);
  });
  headerRow.height = headerHeight;

  // Freeze after header
  const headerRowNumber = selYojna?.yojnaName ? (selVillage.GramYojnaName ? 5 : 4) : selVillage?.GramYojnaName ? 3 : 1;
  worksheet.views = [{ state: "normal", ySplit: headerRowNumber }];

  // === 5. Data Rows (Your Original Logic - 100% Preserved) ===
  let rowIdx = headerRowNumber + 1;
  let zebra = true;

  for (let i = 0; i < data.length; ) {
    const head = data[i];
    const count = head._memberLength || 1;
    const startRow = rowIdx;
    const endRow = startRow + count - 1;
    const bgColor = zebra ? "FFF2F2F2" : "FFFFFFFF";
    zebra = !zebra;

    const rowHeights = Array(count).fill(0);
    for (let j = 0; j < count; j++) {
      const rowData = data[i + j];
      const values = headers.map((h) => rowData[h] ?? "");
      values.forEach((val, idx) => {
        const lines = String(val).split("\n").length;
        rowHeights[j] = Math.max(rowHeights[j], Math.max(15, lines * 15));
      });
    }

    for (let j = 0; j < count; j++) {
      const rowData = data[i + j];
      const row = worksheet.addRow(headers.map((h) => rowData[h] ?? ""));
      row.height = rowHeights[j];

      row.eachCell((cell, colNumber) => {
        const colName = headers[colNumber - 1];
        cell.alignment = {
          wrapText: true,
          vertical: "middle",
          horizontal: typeof cell.value === "number" ? "center" : "center",
        };
        cell.border = {
          top: { style: "thin", color: { argb: borderColor } },
          bottom: { style: "thin", color: { argb: borderColor } },
          left: { style: "thin", color: { argb: borderColor } },
          right: { style: "thin", color: { argb: borderColor } },
        };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
      });
      rowIdx++;
    }

    // Merge logic (your original)
    ["Sr No", "Head Name", "Village", "Locality"].forEach((colName) => {
      const col = headers.indexOf(colName) + 1;
      if (startRow !== endRow && col <= headers.length) {
        worksheet.mergeCells(startRow, col, endRow, col);
        worksheet.getCell(startRow, col).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      }
    });

    i += count;
  }

  // === 6. Column Widths (Auto + Max Limit) ===
  // worksheet.columns.forEach(col => {
  //   const name = col.header;
  //   if (name === "Sr No") {
  //     col.width = 7;
  //     return;
  //   }
  //   let max = 12;
  //   col.eachCell({ includeEmpty: true }, c => {
  //     const len = c.value ? String(c.value).length : 0;
  //     if (len > max) max = len;
  //   });
  //   col.width = Math.min(max + 4, 50);
  // });
  worksheet.columns = [{ width: 10 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 70 }, { width: 30 }];

  // === 7. AutoFilter ===
  // worksheet.autoFilter = {
  //   from: { row: headerRowNumber, column: 1 },
  //   to: { row: headerRowNumber, column: headers.length },
  // };

  // === 8. Save ===
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `${fileName}_${new Date().toISOString().slice(0, 10)}.xlsx`);
};
export const exportVillageWiseGrantDetailsExcel = async (data, fileName = "Grand_Details", options = {}) => {
  debugger;
  if (!data?.length) return;

  const { selYojna, selVillage, tab, showTitle2 = true } = options; // <-- New: Pass from handleExport
  const { columnVertPadding = {} } = options;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Members");

  const headers = Object.keys(data[0]).filter((h) => h !== "_memberLength");
  const borderColor = "FFCCCCCC";
  const headerBg = "FF2F75B5";

  const getVillageDisplayName = (selVillage) => {
    const total = selVillage?.IsYojanaAmount ? Number(selVillage?.YojanaAmount || 0) * Number(selVillage?.TotalAmount || 0) : Number(selVillage?.TotalAmount || 0);

    const amount = `₹${total.toLocaleString("en-IN")}`;

    return `${selVillage?.Village || ""} (${amount})`;
  };

  // === 1. Yojana Name (Big Title) ===
  // const titleRow = worksheet.addRow([selVillage?.Village]);
  const titleRow = worksheet.addRow([getVillageDisplayName(selVillage)]);
  // const titleRow = worksheet.addRow([selVillage?.Village]);
  worksheet.mergeCells(`A${titleRow.number}:F${titleRow.number}`);
  const titleCell = worksheet.getCell(`A${titleRow.number}`);
  titleCell.font = { size: 12, bold: true, color: { argb: "FF1E40AF" } };
  titleCell.alignment = { horizontal: "center", vertical: "middle" };
  titleRow.height = 25;

  if (showTitle2) {
    const titleRow2 = worksheet.addRow([`યોજનાનું નામ: ${selYojna?.YojnaName} |  ગ્રાન્ટ વિગતો ગણતરીઓ : ${selYojna?.GrantDetailCount?.toLocaleString()}`]);
    worksheet.mergeCells(`A${titleRow2.number}:F${titleRow2.number}`);
    const titleCell2 = worksheet.getCell(`A${titleRow2.number}`);
    titleCell2.font = { size: 12, bold: true, color: { argb: "FF1E40AF" } };
    titleCell2.alignment = { horizontal: "center", vertical: "middle" };
    titleRow2.height = 25;
  }

  // === 3. Empty Row (Spacing) ===
  // if (yojnaName || GramYojnaName) {
  //   worksheet.addRow([]).height = 20;
  // }

  // === 4. Table Header ===
  const headerRow = worksheet.addRow(headers);
  let headerHeight = 25;
  headerRow.eachCell((cell, colNumber) => {
    const colName = headers[colNumber - 1];
    const pad = columnVertPadding[colName] ?? 0;

    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: headerBg } };
    cell.border = {
      top: { style: "medium", color: { argb: borderColor } },
      bottom: { style: "medium", color: { argb: borderColor } },
      left: { style: "medium", color: { argb: borderColor } },
      right: { style: "medium", color: { argb: borderColor } },
    };

    if (pad > 0) headerHeight = Math.max(headerHeight, 15 + pad * 2);
  });
  headerRow.height = headerHeight;

  // Freeze after header
  const headerRowNumber = selYojna?.yojnaName ? (selVillage.GramYojnaName ? 5 : 4) : selVillage?.GramYojnaName ? 3 : 1;
  worksheet.views = [{ state: "normal", ySplit: headerRowNumber }];

  // === 5. Data Rows (Your Original Logic - 100% Preserved) ===
  let rowIdx = headerRowNumber + 1;
  let zebra = true;

  for (let i = 0; i < data.length; ) {
    const head = data[i];
    const count = head._memberLength || 1;
    const startRow = rowIdx;
    const endRow = startRow + count - 1;
    const bgColor = zebra ? "FFF2F2F2" : "FFFFFFFF";
    zebra = !zebra;

    const rowHeights = Array(count).fill(0);
    for (let j = 0; j < count; j++) {
      const rowData = data[i + j];
      const values = headers.map((h) => rowData[h] ?? "");
      values.forEach((val, idx) => {
        const lines = String(val).split("\n").length;
        rowHeights[j] = Math.max(rowHeights[j], Math.max(15, lines * 15));
      });
    }

    for (let j = 0; j < count; j++) {
      const rowData = data[i + j];
      const row = worksheet.addRow(headers.map((h) => rowData[h] ?? ""));
      row.height = rowHeights[j];

      row.eachCell((cell, colNumber) => {
        const colName = headers[colNumber - 1];
        cell.alignment = {
          wrapText: true,
          vertical: "middle",
          horizontal: typeof cell.value === "number" ? "center" : "center",
        };
        cell.border = {
          top: { style: "thin", color: { argb: borderColor } },
          bottom: { style: "thin", color: { argb: borderColor } },
          left: { style: "thin", color: { argb: borderColor } },
          right: { style: "thin", color: { argb: borderColor } },
        };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
      });
      rowIdx++;
    }

    // Merge logic (your original)
    ["Sr No", "Head Name", "Village", "Locality"].forEach((colName) => {
      const col = headers.indexOf(colName) + 1;
      if (startRow !== endRow && col <= headers.length) {
        worksheet.mergeCells(startRow, col, endRow, col);
        worksheet.getCell(startRow, col).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      }
    });

    i += count;
  }

  // === 6. Column Widths (Auto + Max Limit) ===
  // worksheet.columns.forEach(col => {
  //   const name = col.header;
  //   if (name === "Sr No") {
  //     col.width = 7;
  //     return;
  //   }
  //   let max = 12;
  //   col.eachCell({ includeEmpty: true }, c => {
  //     const len = c.value ? String(c.value).length : 0;
  //     if (len > max) max = len;
  //   });
  //   col.width = Math.min(max + 4, 50);
  // });
  worksheet.columns = [
    { width: 10 },
    // { width: 30 },
    // { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 70 },
    { width: 30 },
  ];

  // === 7. AutoFilter ===
  // worksheet.autoFilter = {
  //   from: { row: headerRowNumber, column: 1 },
  //   to: { row: headerRowNumber, column: headers.length },
  // };

  // === 8. Save ===
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `${fileName}_${new Date().toISOString().slice(0, 10)}.xlsx`);
};
export const exportBeneficiaryToPDF = (data, options = {}) => {
  const { yojnaName, villageName, fileName, BeneficialCount, TotalAmount } = options;

  const doc = new jsPDF("p", "mm", "a4");

  // Your existing font loader — DO NOT CHANGE
  addGujaratiFont(doc);

  // Title using autoTable (THIS IS THE ONLY WAY THAT WORKS 100%)
  autoTable(doc, {
    body: [[yojnaName], [`Village: ${villageName} | Total Labharthi : ${BeneficialCount} | Amount Disbursed : ${TotalAmount}`]],
    startY: 0,
    theme: "plain",
    pageBreak: "avoid",
    styles: {
      font: "NotoSansGujarati", // ← CRITICAL
      fontSize: 14,
      textColor: [30, 64, 175],
      halign: "center",
      valign: "center",
      cellPadding: 4,
      lineWidth: 0,
    },
    columnStyles: {
      0: { cellWidth: "auto" },
    },
    didDrawCell: (data) => {
      if (data.row.index === 0) {
        doc.setFontSize(18);
        doc.setFont("NotoSansGujarati", "bold");
      } else {
        doc.setFontSize(14);
        doc.setFont("NotoSansGujarati", "normal");
      }
    },
  });

  const finalY = doc.lastAutoTable.finalY + 12;

  // Now your normal table — already working
  autoTable(doc, {
    head: [["No.", "Name", "Mobile No", "Locality"]],
    body: data.map((item, i) => [(i + 1).toString(), item.Name || "-", item.Mobile || "-", item.Locality || "-"]),
    // startY: finalY,
    theme: "grid",
    margin: { left: 12, right: 12 },
    styles: {
      font: "NotoSansGujarati",
      fontSize: 10,
      halign: "center",
      valign: "middle",
    },
    headStyles: {
      fillColor: [47, 117, 181],
      textColor: [255, 255, 255],
      fontStyle: "bold",
      halign: "center",
      valign: "middle",
    },
    columnStyles: {
      0: { cellWidth: 20 },
      1: { cellWidth: 70 },
      2: { cellWidth: 40 },
      3: { cellWidth: 50 },
    },
  });

  // Footer
  doc.setFont("NotoSansGujarati");
  doc.setFontSize(9);
  doc.text(`તારીખ: ${new Date().toLocaleDateString("gu-IN")}`, 105, 285, { align: "center" });

  doc.save(`${fileName}_${new Date().toISOString().slice(0, 10)}.pdf`);
};

export const exportYojnaSummaryToExcel = async (overallDashboardCountData, data, fileName = "Yojna_Summary") => {
  if (!data?.length) {
    toast.error("No data to export");
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Yojna Summary", {
    pageSetup: { paperSize: 9, orientation: "landscape", fitToPage: true, fitToWidth: 1 },
  });

  const blueHeader = "FF2F75B5";
  const greenText = "FF006400";
  const grayText = "FF64748B";
  const lightBg = "FFF8FAFC";

  // Thin border for table cells only
  const tableBorder = {
    top: { style: "thin", color: { argb: "FFCCCCCC" } },
    left: { style: "thin", color: { argb: "FFCCCCCC" } },
    bottom: { style: "thin", color: { argb: "FFCCCCCC" } },
    right: { style: "thin", color: { argb: "FFCCCCCC" } },
  };

  // Title Row
  // const titleRow = worksheet.addRow(["Yojna-wise Summary"]);
  // const titleRow = worksheet.addRow(["યોજના પ્રમાણેનો સારાંશ"]);
  const titleRow = worksheet.addRow(["योजना के अनुसार सारांश"]);
  worksheet.mergeCells("A1:D1");
  const titleCell = worksheet.getCell("A1");
  titleCell.font = { size: 14, bold: true, color: { argb: "FF1E40AF" } };
  titleCell.alignment = { horizontal: "center", vertical: "middle" };
  // worksheet.getRow(1).height = 10;
  titleRow.height = 25;

  // Subtitle
  // const subTitle = worksheet.addRow([
  //   `યોજનાઓ: ${data.length} | મતદારો: ${overallDashboardCountData?.[0]?.OverallVoterCount?.toLocaleString()} |
  // વિતરણ થયેલી રકમ: ₹${overallDashboardCountData?.[0]?.TotalAmount?.toLocaleString()}  | લાભાર્થીઓ: ${overallDashboardCountData?.[0]?.BeneficialCount?.toLocaleString()} | કુલ લાભાર્થી લાભ: ${overallDashboardCountData?.[0]?.TotalLabharthiLabh?.toLocaleString()} `,
  // ]);

  const subTitle = worksheet.addRow([
    `योजनाएं: ${data.length} | मतदाता: ${Number(overallDashboardCountData?.[0]?.OverallVoterCount || 0).toLocaleString()} | वितरित राशि: ₹${Number(overallDashboardCountData?.[0]?.TotalAmount || 0).toLocaleString()} | लाभार्थी: ${Number(overallDashboardCountData?.[0]?.BeneficialCount || 0).toLocaleString()} | कुल लाभार्थी लाभ: ${Number(overallDashboardCountData?.[0]?.TotalLabharthiLabh || 0).toLocaleString()}`,
  ]);
  worksheet.mergeCells("A2:D2");
  const subCell = worksheet.getCell("A2");
  subCell.font = { size: 13, bold: true, color: { argb: "FF1E40AF" } };
  subCell.alignment = { horizontal: "center", vertical: "middle" };
  subTitle.height = 25;
  // worksheet.getRow(2).height = 10;

  // Empty row
  // worksheet.addRow([]);
  // worksheet.getRow(3).height = 15;

  // Header Row (Row 4)
  // const headerRow = worksheet.addRow(["ક્રમાંક", "યોજનાનું નામ", "લાભાર્થી", "રકમ"]);
  const headerRow = worksheet.addRow(["क्रमांक", "योजना का नाम", "लाभार्थी", "राशि"]);
  headerRow.eachCell((cell) => {
    cell.font = { bold: true, size: 12, color: { argb: "FFFFFFFF" } };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: blueHeader } };
    cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    cell.border = tableBorder; // Border on header
  });
  headerRow.height = 25;

  // Data Rows
  data.forEach((y, i) => {
    const row = worksheet.addRow([i + 1, y.GramYojnaName || "-", y.BeneficialCount?.toLocaleString() || "0", y.TotalAmount ? `₹ ${y.TotalAmount.toLocaleString()}` : "-"]);

    const isEven = i % 2 === 0;
    row.eachCell((cell, colNum) => {
      cell.alignment = { vertical: "middle", horizontal: colNum === 2 ? "center" : "center", wrapText: true };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: isEven ? lightBg : "FFFFFFFF" } };

      if (colNum === 3) {
        cell.font = { bold: true, color: { argb: greenText }, size: 11 };
      } else {
        cell.font = { size: 11 };
      }

      // ADD BORDER TO EVERY DATA CELL
      cell.border = tableBorder;
    });
    row.height = 25;
  });

  // Column Widths
  worksheet.columns = [{ width: 10 }, { width: 70 }, { width: 18 }, { width: 40 }];

  worksheet.views = [{ state: "frozen", ySplit: 3 }];
  worksheet.headerFooter.firstHeader = `&L&14&B${fileName}`;
  worksheet.headerFooter.firstFooter = `&CPage &P of &N`;

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  saveAs(blob, `${fileName}_${new Date().toISOString().slice(0, 10)}.xlsx`);
  // toast.success("Excel downloaded successfully!");
};
export const exportGrantYojanaToExcel = async (overallDashboardCountData, data, fileName = "Grant_Yojna_Summary") => {
  if (!data?.length) {
    toast.error("No data to export");
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Yojna Summary", {
    pageSetup: { paperSize: 9, orientation: "landscape", fitToPage: true, fitToWidth: 1 },
  });

  const blueHeader = "FF2F75B5";
  const greenText = "FF006400";
  const grayText = "FF64748B";
  const lightBg = "FFF8FAFC";

  // Thin border for table cells only
  const tableBorder = {
    top: { style: "thin", color: { argb: "FFCCCCCC" } },
    left: { style: "thin", color: { argb: "FFCCCCCC" } },
    bottom: { style: "thin", color: { argb: "FFCCCCCC" } },
    right: { style: "thin", color: { argb: "FFCCCCCC" } },
  };

  // Title Row
  // const titleRow = worksheet.addRow(["Yojna-wise Summary"]);
  const titleRow = worksheet.addRow(["ગ્રાન્ટ યોજના પ્રમાણેનો સારાંશ"]);
  worksheet.mergeCells("A1:D1");
  const titleCell = worksheet.getCell("A1");
  titleCell.font = { size: 14, bold: true, color: { argb: "FF1E40AF" } };
  titleCell.alignment = { horizontal: "center", vertical: "middle" };
  // worksheet.getRow(1).height = 10;
  titleRow.height = 25;

  // Subtitle
  const subTitle = worksheet.addRow([
    `યોજનાઓ: ${data.length}  | 
  વિતરણ થયેલી રકમ: ₹${overallDashboardCountData?.[0]?.OverallAmount?.toLocaleString()}  | કુલ લાભાર્થી ગામ: ${overallDashboardCountData?.[0]?.OverallVillageCount?.toLocaleString()} `,
  ]);
  worksheet.mergeCells("A2:D2");
  const subCell = worksheet.getCell("A2");
  subCell.font = { size: 13, bold: true, color: { argb: "FF1E40AF" } };
  subCell.alignment = { horizontal: "center", vertical: "middle" };
  subTitle.height = 25;
  // worksheet.getRow(2).height = 10;

  // Empty row
  // worksheet.addRow([]);
  // worksheet.getRow(3).height = 15;

  // Header Row (Row 4)
  const headerRow = worksheet.addRow(["ક્રમાંક", "યોજનાનું નામ", "રકમ", "લાભાર્થી ગામ"]);
  headerRow.eachCell((cell) => {
    cell.font = { bold: true, size: 12, color: { argb: "FFFFFFFF" } };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: blueHeader } };
    cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    cell.border = tableBorder; // Border on header
  });
  headerRow.height = 25;

  // Data Rows
  data.forEach((y, i) => {
    const row = worksheet.addRow([
      i + 1,
      y.GrantYojnaName || "-",
      y?.IsYojanaAmount == 1 ? `₹${(parseInt(y?.YojanaAmount || 0) * parseInt(y?.TotalAmount || 0))?.toLocaleString() || "-"}` : `₹${y?.TotalAmount?.toLocaleString() || "-"}`,
      y.VillageCount?.toLocaleString() || "0",
    ]);
    // const row = worksheet.addRow([i + 1, y.GrantYojnaName || "-", y?.TotalAmount ? "₹ " + y?.TotalAmount.toLocaleString() : "-", y.VillageCount?.toLocaleString() || "0"]);

    const isEven = i % 2 === 0;
    row.eachCell((cell, colNum) => {
      cell.alignment = { vertical: "middle", horizontal: colNum === 2 ? "center" : "center", wrapText: true };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: isEven ? lightBg : "FFFFFFFF" } };

      if (colNum === 3) {
        cell.font = { bold: true, color: { argb: greenText }, size: 11 };
      } else {
        cell.font = { size: 11 };
      }

      // ADD BORDER TO EVERY DATA CELL
      cell.border = tableBorder;
    });
    row.height = 25;
  });

  // Column Widths
  worksheet.columns = [{ width: 10 }, { width: 70 }, { width: 40 }, { width: 40 }];

  worksheet.views = [{ state: "frozen", ySplit: 3 }];
  worksheet.headerFooter.firstHeader = `&L&14&B${fileName}`;
  worksheet.headerFooter.firstFooter = `&CPage &P of &N`;

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  saveAs(blob, `${fileName}_${new Date().toISOString().slice(0, 10)}.xlsx`);
  // toast.success("Excel downloaded successfully!");
};

export const exportGrantVillageWiseYojanaToExcel = async (overallDashboardCountData, data, fileName = "Grant_Yojna_Summary") => {
  if (!data?.length) {
    toast.error("No data to export");
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Yojna Summary", {
    pageSetup: { paperSize: 9, orientation: "landscape", fitToPage: true, fitToWidth: 1 },
  });

  const blueHeader = "FF2F75B5";
  const greenText = "FF006400";
  const grayText = "FF64748B";
  const lightBg = "FFF8FAFC";

  // Thin border for table cells only
  const tableBorder = {
    top: { style: "thin", color: { argb: "FFCCCCCC" } },
    left: { style: "thin", color: { argb: "FFCCCCCC" } },
    bottom: { style: "thin", color: { argb: "FFCCCCCC" } },
    right: { style: "thin", color: { argb: "FFCCCCCC" } },
  };

  // Title Row
  // const titleRow = worksheet.addRow(["Yojna-wise Summary"]);
  const titleRow = worksheet.addRow(["અનુદાનનો ગામવાઇઝ સારાંશ"]);
  worksheet.mergeCells("A1:D1");
  const titleCell = worksheet.getCell("A1");
  titleCell.font = { size: 14, bold: true, color: { argb: "FF1E40AF" } };
  titleCell.alignment = { horizontal: "center", vertical: "middle" };
  // worksheet.getRow(1).height = 10;
  titleRow.height = 25;

  // Subtitle
  const subTitle = worksheet.addRow([
    `ગામ: ${data.length}  | 
  વિતરણ થયેલી રકમ: ₹${overallDashboardCountData?.[0]?.OverallAmount?.toLocaleString()}  | કુલ લાભાર્થી ગામ: ${overallDashboardCountData?.[0]?.OverallVillageCount?.toLocaleString()} `,
  ]);
  worksheet.mergeCells("A2:D2");
  const subCell = worksheet.getCell("A2");
  subCell.font = { size: 13, bold: true, color: { argb: "FF1E40AF" } };
  subCell.alignment = { horizontal: "center", vertical: "middle" };
  subTitle.height = 25;
  // worksheet.getRow(2).height = 10;

  // Empty row
  // worksheet.addRow([]);
  // worksheet.getRow(3).height = 15;

  // Header Row (Row 4)
  const headerRow = worksheet.addRow(["ક્રમાંક", "ગામનું નામ", "રકમ", "અનુદાન યોજના ગણતરી"]);
  headerRow.eachCell((cell) => {
    cell.font = { bold: true, size: 12, color: { argb: "FFFFFFFF" } };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: blueHeader } };
    cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    cell.border = tableBorder; // Border on header
  });
  headerRow.height = 25;

  // Data Rows
  data.forEach((y, i) => {
    const row = worksheet.addRow([i + 1, y.Village || "-", y?.TotalAmount ? "₹ " + y?.TotalAmount.toLocaleString() : "-", y.GrantYojnaCount?.toLocaleString() || "0"]);

    const isEven = i % 2 === 0;
    row.eachCell((cell, colNum) => {
      cell.alignment = { vertical: "middle", horizontal: colNum === 2 ? "center" : "center", wrapText: true };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: isEven ? lightBg : "FFFFFFFF" } };

      if (colNum === 3) {
        cell.font = { bold: true, color: { argb: greenText }, size: 11 };
      } else {
        cell.font = { size: 11 };
      }

      // ADD BORDER TO EVERY DATA CELL
      cell.border = tableBorder;
    });
    row.height = 25;
  });

  // Column Widths
  worksheet.columns = [{ width: 10 }, { width: 70 }, { width: 40 }, { width: 40 }];

  worksheet.views = [{ state: "frozen", ySplit: 3 }];
  worksheet.headerFooter.firstHeader = `&L&14&B${fileName}`;
  worksheet.headerFooter.firstFooter = `&CPage &P of &N`;

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  saveAs(blob, `${fileName}_${new Date().toISOString().slice(0, 10)}.xlsx`);
  // toast.success("Excel downloaded successfully!");
};

// PDF Export - 100% Safe Gujarati (uses only autoTable)
export const exportYojnaSummaryToPDF = (overallDashboardCountData, data, fileName = "Yojna_Summary") => {
  if (!data?.length) {
    toast.error("No data to export");
    return;
  }

  const doc = new jsPDF("p", "mm", "a4");
  addGujaratiFont(doc);

  // Title (using autoTable - NO doc.text()!)
  autoTable(doc, {
    body: [["Yojna-wise Summary"]],
    theme: "plain",
    styles: { fontSize: 20, fontStyle: "bold", textColor: [30, 64, 175], halign: "center", valign: "middle" },
    margin: { top: 5 },
  });

  autoTable(doc, {
    body: [
      [
        `Total Yojana: ${data.length} | Total Voters: ${overallDashboardCountData?.[0]?.OverallVoterCount} | 
    Total Amount Disbursed: ${overallDashboardCountData?.[0]?.TotalAmount}  | Total Labharthi: ${overallDashboardCountData?.[0]?.BeneficialCount} `,
      ],
    ],
    theme: "plain",
    styles: { fontSize: 14, halign: "center", valign: "middle" },
    margin: { top: 1 },
  });

  const tableData = data.map((y, i) => [
    (i + 1).toString(),
    y.GramYojnaName || "-",
    y.BeneficialCount?.toLocaleString() || "0",
    y.TotalAmount ? `₹${y.TotalAmount.toLocaleString()}` : "-",
    // "Active"
  ]);

  autoTable(doc, {
    head: [["No", "Yojana Name", "Labharthi", "Total Amount"]],
    body: tableData,
    // startY: doc.lastAutoTable.finalY + 15,
    theme: "grid",
    headStyles: { fillColor: [47, 117, 181], textColor: [255, 255, 255], fontStyle: "bold", halign: "center", valign: "middle" },
    styles: { font: "NotoSansGujarati", fontSize: 11, cellPadding: 1 },
    columnStyles: {
      0: { halign: "center" },
      1: { halign: "center" },
      2: { halign: "center" },
      3: { halign: "center" },
    },
    alternateRowStyles: { fillColor: [248, 250, 252] },
  });

  const pageHeight = doc.internal.pageSize.height;
  doc.setFont("NotoSansGujarati");
  doc.setFontSize(9);
  doc.setTextColor(100);
  doc.text(`જનરેટ તારીખ: ${new Date().toLocaleDateString("gu-IN")}`, 105, pageHeight - 10, { align: "center" });

  doc.save(`${fileName}_${new Date().toISOString().slice(0, 10)}.pdf`);
  // toast.success("PDF downloaded successfully!");
};

// 1. EXCEL EXPORT — Exactly like your Yojna Summary (clean & compact)
export const exportVillagesToExcel = async (selYojna = null, data, fileName = "Villages_Report") => {
  if (!data?.length) {
    toast.error("No villages to export");
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Villages", {
    pageSetup: { paperSize: 9, orientation: "landscape", fitToPage: true, fitToWidth: 1 },
  });

  const blueHeader = "FF2F75B5";
  const greenText = "FF006400";
  const lightBg = "FFF8FAFC";

  const tableBorder = {
    top: { style: "thin", color: { argb: "FFCCCCCC" } },
    left: { style: "thin", color: { argb: "FFCCCCCC" } },
    bottom: { style: "thin", color: { argb: "FFCCCCCC" } },
    right: { style: "thin", color: { argb: "FFCCCCCC" } },
  };

  // Title
  worksheet.addRow([selYojna?.GramYojnaName || ""]);
  worksheet.mergeCells("A1:E1");
  worksheet.getCell("A1").font = { size: 14, bold: true, color: { argb: "FF1E40AF" } };
  worksheet.getCell("A1").alignment = { horizontal: "center", vertical: "middle" };
  worksheet.getRow(1).height = 25;

  // Subtitle
  worksheet.addRow([`કુલ ગામો: ${data.length} | લાભાર્થી: ${selYojna?.BeneficialCount?.toLocaleString()} | રકમ: ${selYojna?.TotalAmount?.toLocaleString()} `]);
  worksheet.mergeCells("A2:E2");
  worksheet.getCell("A2").font = { size: 12, bold: true, color: { argb: "FF1E40AF" } };
  worksheet.getCell("A2").alignment = { horizontal: "center", vertical: "middle" };
  worksheet.getRow(2).height = 25;

  // Header Row
  const headerRow = worksheet.addRow(["ક્રમ નં", "ગામનું નામ", "લાભાર્થી", "મતદારો", "કુલ રકમ"]);
  headerRow.eachCell((cell) => {
    cell.font = { bold: true, size: 13, color: { argb: "FFFFFFFF" } };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: blueHeader } };
    cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    cell.border = tableBorder;
  });
  headerRow.height = 25;

  // Data Rows
  data.forEach((v, i) => {
    const row = worksheet.addRow([
      i + 1,
      v.VillageNameEnglish || "-",
      v.BeneficialCount?.toLocaleString() || "0",
      v.VillageVoterCount?.toLocaleString() || "-",
      v.TotalAmount > 0 ? `₹${v.TotalAmount.toLocaleString()}` : "-",
    ]);

    const isEven = i % 2 === 0;
    row.eachCell((cell, colNum) => {
      cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: isEven ? lightBg : "FFFFFFFF" } };
      cell.border = tableBorder;

      if (colNum === 5) cell.font = { bold: true, color: { argb: greenText } }; // Amount
      if (colNum === 1) cell.font = { size: 12, bold: false };
    });
    row.height = 25;
  });

  worksheet.columns = [{ width: 10 }, { width: 45 }, { width: 18 }, { width: 16 }, { width: 22 }];

  worksheet.views = [{ state: "frozen", ySplit: 3 }];
  worksheet.headerFooter.firstHeader = `&L&14&B${fileName}`;
  worksheet.headerFooter.firstFooter = `&CPage &P of &N`;

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  saveAs(blob, `${fileName}_${new Date().toISOString().slice(0, 10)}.xlsx`);
};
export const exportGrantVillagesToExcel = async (selYojna = null, data, fileName = "Villages_Report") => {
  if (!data?.length) {
    toast.error("No villages to export");
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Villages", {
    pageSetup: { paperSize: 9, orientation: "landscape", fitToPage: true, fitToWidth: 1 },
  });

  const blueHeader = "FF2F75B5";
  const greenText = "FF006400";
  const lightBg = "FFF8FAFC";

  const tableBorder = {
    top: { style: "thin", color: { argb: "FFCCCCCC" } },
    left: { style: "thin", color: { argb: "FFCCCCCC" } },
    bottom: { style: "thin", color: { argb: "FFCCCCCC" } },
    right: { style: "thin", color: { argb: "FFCCCCCC" } },
  };

  // Title
  worksheet.addRow([selYojna?.GrantYojnaName || ""]);
  worksheet.mergeCells("A1:D1");
  worksheet.getCell("A1").font = { size: 14, bold: true, color: { argb: "FF1E40AF" } };
  worksheet.getCell("A1").alignment = { horizontal: "center", vertical: "middle" };
  worksheet.getRow(1).height = 25;

  worksheet.addRow([`લાભાર્થી ગામ: ${selYojna?.VillageCount?.toLocaleString()}  `]);
  worksheet.mergeCells("A2:D2");
  worksheet.getCell("A2").font = { size: 12, bold: true, color: { argb: "FF1E40AF" } };
  worksheet.getCell("A2").alignment = { horizontal: "center", vertical: "middle" };
  worksheet.getRow(2).height = 25;

  // Header Row
  const headerRow = worksheet.addRow(["ક્રમ નં", "ગામનું નામ", "રકમ", "ગ્રાન્ટ વિગતો ગણતરીઓ"]);
  headerRow.eachCell((cell) => {
    cell.font = { bold: true, size: 13, color: { argb: "FFFFFFFF" } };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: blueHeader } };
    cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    cell.border = tableBorder;
  });
  headerRow.height = 25;

  // Data Rows
  data.forEach((v, i) => {
    const amountDisplay = v.IsYojanaAmount
      ? `₹${parseFloat(v.YojanaAmount)} × ${parseFloat(v.TotalAmount)} = ₹${(parseFloat(v.YojanaAmount) * parseFloat(v.TotalAmount))?.toLocaleString()}`
      : `₹${v?.TotalAmount?.toLocaleString()}`;
    // ? `₹${v.TotalAmount.toLocaleString()}`
    // : "";
    const row = worksheet.addRow([
      i + 1,
      v.Village || "-",
      // v?.TotalAmount ? ("₹ " + v?.TotalAmount.toLocaleString()) : "-",
      amountDisplay,
      v.GrantDetailCount?.toLocaleString() || "0",
    ]);

    const isEven = i % 2 === 0;
    row.eachCell((cell, colNum) => {
      cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: isEven ? lightBg : "FFFFFFFF" } };
      cell.border = tableBorder;

      // if (colNum === 5) cell.font = { bold: true, color: { argb: greenText } }; // Amount
      // if (colNum === 1) cell.font = { size: 12, bold: false };
    });
    row.height = 25;
  });

  worksheet.columns = [{ width: 10 }, { width: 45 }, { width: 40 }, { width: 40 }];

  worksheet.views = [{ state: "frozen", ySplit: 3 }];
  worksheet.headerFooter.firstHeader = `&L&14&B${fileName}`;
  worksheet.headerFooter.firstFooter = `&CPage &P of &N`;

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  saveAs(blob, `${fileName}_${new Date().toISOString().slice(0, 10)}.xlsx`);
};

export const exportGrantYojanaUnderVillageToExcel = async (selVillage = null, data, fileName = "Villages_Report") => {
  if (!data?.length) {
    toast.error("No Yojana to export");
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Villages", {
    pageSetup: { paperSize: 9, orientation: "landscape", fitToPage: true, fitToWidth: 1 },
  });

  const blueHeader = "FF2F75B5";
  const greenText = "FF006400";
  const lightBg = "FFF8FAFC";

  const tableBorder = {
    top: { style: "thin", color: { argb: "FFCCCCCC" } },
    left: { style: "thin", color: { argb: "FFCCCCCC" } },
    bottom: { style: "thin", color: { argb: "FFCCCCCC" } },
    right: { style: "thin", color: { argb: "FFCCCCCC" } },
  };

  // Title
  // worksheet.addRow([selVillage?.Village || ""]);

  const getVillageDisplayName = (selVillage) => {
    const total = selVillage?.IsYojanaAmount ? Number(selVillage?.YojanaAmount || 0) * Number(selVillage?.TotalAmount || 0) : Number(selVillage?.TotalAmount || 0);

    const amount = selVillage?.IsYojanaAmount ? toIndianCurrencyHeader(total) : `₹${total.toLocaleString("en-IN")}`;

    return `${selVillage?.Village || ""} (${amount})`;
  };
  worksheet.addRow([getVillageDisplayName(selVillage)]);

  worksheet.mergeCells("A1:D1");
  worksheet.getCell("A1").font = { size: 14, bold: true, color: { argb: "FF1E40AF" } };
  worksheet.getCell("A1").alignment = { horizontal: "center", vertical: "middle" };
  worksheet.getRow(1).height = 25;

  worksheet.addRow([`યોજના: ${selVillage?.GrantYojnaCount?.toLocaleString()}  `]);
  worksheet.mergeCells("A2:D2");
  worksheet.getCell("A2").font = { size: 12, bold: true, color: { argb: "FF1E40AF" } };
  worksheet.getCell("A2").alignment = { horizontal: "center", vertical: "middle" };
  worksheet.getRow(2).height = 25;

  // Header Row
  const headerRow = worksheet.addRow(["ક્રમ નં", "યોજનાનું નામ", "રકમ", "ગ્રાન્ટ વિગતો ગણતરીઓ"]);
  headerRow.eachCell((cell) => {
    cell.font = { bold: true, size: 13, color: { argb: "FFFFFFFF" } };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: blueHeader } };
    cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    cell.border = tableBorder;
  });
  headerRow.height = 25;

  // Data Rows
  data.forEach((v, i) => {
    const displayAmount = v?.IsYojanaAmount
      ? `₹${parseFloat(v?.TotalAmount || 0) * parseFloat(v?.YojanaAmount || 0)}`
      : v?.TotalAmount
        ? `₹${v?.TotalAmount?.toLocaleString()}`
        : "";
    // const row = worksheet.addRow([i + 1, v.YojnaName || "-", v?.TotalAmount ? "₹ " + v?.TotalAmount.toLocaleString() : "-", v.GrantDetailCount?.toLocaleString() || "0"]);
    const row = worksheet.addRow([i + 1, v.YojnaName || "-", displayAmount, v.GrantDetailCount?.toLocaleString() || "0"]);

    const isEven = i % 2 === 0;
    row.eachCell((cell, colNum) => {
      cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: isEven ? lightBg : "FFFFFFFF" } };
      cell.border = tableBorder;

      // if (colNum === 5) cell.font = { bold: true, color: { argb: greenText } }; // Amount
      // if (colNum === 1) cell.font = { size: 12, bold: false };
    });
    row.height = 25;
  });

  worksheet.columns = [{ width: 10 }, { width: 45 }, { width: 40 }, { width: 40 }];

  worksheet.views = [{ state: "frozen", ySplit: 3 }];
  worksheet.headerFooter.firstHeader = `&L&14&B${fileName}`;
  worksheet.headerFooter.firstFooter = `&CPage &P of &N`;

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  saveAs(blob, `${fileName}_${new Date().toISOString().slice(0, 10)}.xlsx`);
};
// PDF EXPORT (100% working with your current font)
// 2. PDF EXPORT — 100% matches your Yojna Summary style
export const exportVillagesToPDF = (selYojna = null, data, fileName = "Villages_Report") => {
  if (!data?.length) {
    toast.error("No villages to export");
    return;
  }
  console.log(selYojna, "selYojnaselYojna");
  const doc = new jsPDF("p", "mm", "a4");
  addGujaratiFont(doc);

  // Title & Subtitle — same compact style
  autoTable(doc, {
    body: [[selYojna?.GramYojnaName || ""]],
    theme: "plain",
    startY: 0,
    theme: "plain",
    pageBreak: "avoid",
    styles: {
      font: "NotoSansGujarati", // ← CRITICAL
      fontSize: 14,
      textColor: [30, 64, 175],
      halign: "center",
      valign: "center",
      cellPadding: 4,
      lineWidth: 0,
    },
    columnStyles: {
      0: { cellWidth: "auto" },
    },
    didDrawCell: (data) => {
      doc.setFontSize(18);
      doc.setFont("NotoSansGujarati", "bold");
    },
  });

  autoTable(doc, {
    body: [[`Total Villages: ${data.length} | Labharti: ${selYojna?.BeneficialCount} | Amount: ${selYojna?.TotalAmount} `]],
    theme: "plain",
    styles: { fontSize: 14, halign: "center", textColor: [30, 64, 175] },
  });

  const tableData = data.map((v, i) => [
    (i + 1).toString(),
    v.VillageNameEnglish || "-",
    v.BeneficialCount?.toLocaleString() || "0",
    v.VillageVoterCount?.toLocaleString() || "-",
    v.TotalAmount > 0 ? `₹${v.TotalAmount.toLocaleString()}` : "-",
  ]);

  autoTable(doc, {
    head: [["No", "Village Name", "Labharthi", "Voters", "Total Amount"]],
    body: tableData,
    // startY: doc.lastAutoTable.finalY + 10,
    theme: "grid",
    margin: { left: 14, right: 14 },

    headStyles: {
      fillColor: [47, 117, 181],
      textColor: [255, 255, 255],
      fontStyle: "bold",
      fontSize: 12,
      font: "NotoSansGujarati",
      halign: "center",
      // cellPadding: 6
    },

    bodyStyles: {
      font: "NotoSansGujarati",
      fontSize: 11,
      // cellPadding: 5,
      halign: "center",
    },

    // columnStyles: {
    //   0: { cellWidth: 18 },
    //   1: { cellWidth: 85 },
    //   2: { cellWidth: 32 },
    //   3: { cellWidth: 28 },
    //   4: { cellWidth: 34 }
    // },

    alternateRowStyles: { fillColor: [248, 250, 252] },

    didDrawCell: () => {
      doc.setFont("NotoSansGujarati");
    },
  });

  const pageHeight = doc.internal.pageSize.height;
  doc.setFont("NotoSansGujarati");
  doc.setFontSize(9);
  doc.setTextColor(100);
  doc.text(`જનરેટ તારીખ: ${new Date().toLocaleDateString("gu-IN")}`, 105, pageHeight - 10, { align: "center" });

  doc.save(`${fileName}_${new Date().toISOString().slice(0, 10)}.pdf`);
};

const addGujaratiFont = (doc) => {
  doc.addFileToVFS("NotoSansGujarati.ttf", gujaratiFont);
  doc.addFont("NotoSansGujarati.ttf", "NotoSansGujarati", "normal");
  doc.setFont("NotoSansGujarati");
};
// export const addGujaratiFont = async (doc) => {
//   try {
//     const regularRes = await fetch('/NarendraModi/langFonts/NotoSansGujarati-Regular.ttf');
//     const boldRes    = await fetch('/NarendraModi/langFonts/NotoSansGujarati-Bold.ttf');

//     if (!regularRes.ok || !boldRes.ok) {
//       throw new Error('Gujarati font files not found or inaccessible');
//     }

//     const regularBuffer = await regularRes.arrayBuffer();
//     const boldBuffer    = await boldRes.arrayBuffer();

//     const toBase64 = (buffer) => btoa(String.fromCharCode(...new Uint8Array(buffer)));

//     const regularBase64 = toBase64(regularBuffer);
//     const boldBase64    = toBase64(boldBuffer);

//     // Add to VFS
//     doc.addFileToVFS('NotoSansGujarati-Regular.ttf', regularBase64);
//     doc.addFileToVFS('NotoSansGujarati-Bold.ttf',    boldBase64);

//     // Register with SAME family name → this is crucial!
//     doc.addFont('NotoSansGujarati-Regular.ttf', 'GujaratiFont', 'normal');
//     doc.addFont('NotoSansGujarati-Bold.ttf',    'GujaratiFont', 'bold');

//     // THIS LINE IS ABSOLUTELY REQUIRED — otherwise text is garbled!
//     doc.setFont('GujaratiFont'); // sets default font (normal style)

//     console.log("Gujarati fonts loaded & ready!");

//   } catch (err) {
//     console.error("Failed to load Gujarati fonts:", err);
//     // Fallback to Helvetica (so PDF still generates)
//     doc.setFont('helvetica');
//   }
// };
export const handleError = (formik, name) => {
  return formik.touched[name] && formik.errors[name] ? (
    <div style={{ fontSize: "0.9em" }} className="text-danger text-left  ">
      <strong>{formik.errors[name]}</strong>
    </div>
  ) : null;
};

export const validateStartAndEndDate = (startDate, endDate) => {
  // if (!startDate || !endDate) return ""; // Skip validation if either is missing

  const start = new Date(startDate);
  const end = new Date(endDate);
  if (end < start || (endDate && !startDate)) {
    return false;
  }

  return true;
};

export const formatTime = (dateTime) => {
  if (!dateTime) return "";
  return new Date(dateTime).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

// export const formatDateTime = (dateTime) => {
//   if (!dateTime) return "";
//   const formattedDateTime = new Date(dateTime).toLocaleString([], {
//     year: "numeric",
//     month: "2-digit",
//     day: "2-digit",
//     hour: "2-digit",
//     minute: "2-digit",
//     second: "2-digit"
//   })
//   return formattedDateTime;
// }

export const formatDateTime = (dateTime) => {
  console.log("dateTimeDAteTimeDatetime>>>>>>>>>", dateTime);
  if (!dateTime) return "";

  const date = new Date(dateTime);
  console.log("dateTimeDateTimeObject", date);

  const dd = String(date.getDate()).padStart(2, "0");
  console.log("dddddddddddddddd", dd);
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  console.log("mmmmmmmmmmmmmmmm", dd);
  const yyyy = date.getFullYear();
  console.log("yyyyyyyyyyyyyyyyyyyyyyyy", yyyy);
  const hh = String(date.getHours()).padStart(2, "0");
  const min = String(date.getMinutes()).padStart(2, "0");
  const ss = String(date.getSeconds()).padStart(2, "0");
  console.log("checkingTimeZone", Intl.DateTimeFormat().resolvedOptions().timeZone);
  return `${dd}-${mm}-${yyyy} ${hh}:${min}:${ss}`;
};

// export function formatUtcToLocalDate(utcDateTime) {
//   if (!utcDateTime) return "";

//   // Convert to Date object
//   const dateObj = new Date(utcDateTime);

//   // Extract parts in local timezone
//   const day = String(dateObj.getDate()).padStart(2, "0");
//   const month = String(dateObj.getMonth() + 1).padStart(2, "0");
//   const year = dateObj.getFullYear();

//   const hours = String(dateObj.getHours()).padStart(2, "0");
//   const minutes = String(dateObj.getMinutes()).padStart(2, "0");
//   const seconds = String(dateObj.getSeconds()).padStart(2, "0");

//   return `${day}-${month}-${year}`;
// }

export const isNonEmptyArray = (value) => Array.isArray(value) && value.length > 0;

export const isAllowed = (page, action, pageActions) => {
  console.log("pageActionsPageActions", pageActions);
  return pageActions?.[page]?.[action] === true;
};

export function formatUtcToLocalDate(utcDateTime) {
  if (!utcDateTime) return "";

  // Convert to Date object
  const dateObj = new Date(utcDateTime);

  // Extract parts in local timezone
  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const year = dateObj.getFullYear();

  const hours = String(dateObj.getHours()).padStart(2, "0");
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");
  const seconds = String(dateObj.getSeconds()).padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
}

export function numberToHindiWords(num) {
  if (num == null || isNaN(num)) return { words: "", decimalPart: "" };

  const map1To99 = {
    1: "एक",
    2: "दो",
    3: "तीन",
    4: "चार",
    5: "पाँच",
    6: "छह",
    7: "सात",
    8: "आठ",
    9: "नौ",
    10: "दस",
    11: "ग्यारह",
    12: "बारह",
    13: "तेरह",
    14: "चौदह",
    15: "पंद्रह",
    16: "सोलह",
    17: "सत्रह",
    18: "अठारह",
    19: "उन्नीस",
    20: "बीस",
    21: "इक्कीस",
    22: "बाईस",
    23: "तेईस",
    24: "चौबीस",
    25: "पच्चीस",
    26: "छब्बीस",
    27: "सत्ताईस",
    28: "अट्ठाईस",
    29: "उनतीस",
    30: "तीस",
    31: "इकत्तीस",
    32: "बत्तीस",
    33: "तैंतीस",
    34: "चौंतीस",
    35: "पैंतीस",
    36: "छत्तीस",
    37: "सैंतीस",
    38: "अड़तीस",
    39: "उनतालीस",
    40: "चालीस",
    41: "इकतालीस",
    42: "बयालीस",
    43: "तैंतालीस",
    44: "चौवालीस",
    45: "पैंतालीस",
    46: "छियालीस",
    47: "सैंतालीस",
    48: "अड़तालीस",
    49: "उनचास",
    50: "पचास",
    51: "इक्यावन",
    52: "बावन",
    53: "तिरपन",
    54: "चौवन",
    55: "पचपन",
    56: "छप्पन",
    57: "सत्तावन",
    58: "अट्ठावन",
    59: "उनसठ",
    60: "साठ",
    61: "इकसठ",
    62: "बासठ",
    63: "तिरसठ",
    64: "चौंसठ",
    65: "पैंसठ",
    66: "छियासठ",
    67: "सरसठ",
    68: "अड़सठ",
    69: "उनहत्तर",
    70: "सत्तर",
    71: "इकहत्तर",
    72: "बहत्तर",
    73: "तिहत्तर",
    74: "चौहत्तर",
    75: "पचहत्तर",
    76: "छिहत्तर",
    77: "सतहत्तर",
    78: "अठहत्तर",
    79: "उन्नासी",
    80: "अस्सी",
    81: "इक्यासी",
    82: "बयासी",
    83: "तिरासी",
    84: "चौरासी",
    85: "पचासी",
    86: "छियासी",
    87: "सत्तासी",
    88: "अट्ठासी",
    89: "नवासी",
    90: "नब्बे",
    91: "इक्यानवे",
    92: "बानवे",
    93: "तिरानवे",
    94: "चौरानवे",
    95: "पंचानवे",
    96: "छियानवे",
    97: "सत्तानवे",
    98: "अट्ठानवे",
    99: "निन्यानवे",
  };

  const units = [
    { value: 1000000000000000, label: "पद्म" }, // 10^15
    { value: 10000000000000, label: "नील" }, // 10^13
    { value: 100000000000, label: "खरब" }, // 10^11
    { value: 1000000000, label: "अरब" }, // 10^9
    { value: 10000000, label: "करोड़" }, // 10^7
    { value: 100000, label: "लाख" },
    { value: 1000, label: "हजार" },
    { value: 100, label: "सौ" },
  ];

  // 🔒 Force 2 decimals to avoid JS issues
  const [intPart, decimalPart] = Number(num).toFixed(2).split(".");
  let n = parseInt(intPart, 10);

  let words = "";
  if (n === 0) {
    words = "शून्य रुपये";
  }

  // Integer part
  if (n >= 100) {
    for (const unit of units) {
      if (n >= unit.value) {
        const count = Math.floor(n / unit.value);
        words += (map1To99[count] || count) + " " + unit.label + " ";
        n %= unit.value;
      }
    }
  }

  if (n > 0) words += map1To99[n] || n;

  words = words.trim() + " रुपये";

  // Paisa part
  const paise = parseInt(decimalPart, 10);
  if (paise > 0) {
    words += " " + (map1To99[paise] || paise) + " पैसे";
  }

  return { words: words.trim(), decimalPart: decimalPart };
}

// function numberToGujaratiWords(num) {
//   if (num == null || isNaN(num)) return "";

//   const map1To99 = {
//     1: "એક",
//     2: "બે",
//     3: "ત્રણ",
//     4: "ચાર",
//     5: "પાંચ",
//     6: "છ",
//     7: "સાત",
//     8: "આઠ",
//     9: "નવ",
//     10: "દસ",
//     11: "અગિયાર",
//     12: "બાર",
//     13: "તેર",
//     14: "ચૌદ",
//     15: "પંદર",
//     16: "સોળ",
//     17: "સત્તર",
//     18: "અઢાર",
//     19: "ઓગણીસ",
//     20: "વીસ",
//     21: "એકવીસ",
//     22: "બાવીસ",
//     23: "તેઈસ",
//     24: "ચોવીસ",
//     25: "પચ્ચીસ",
//     26: "છવીસ",
//     27: "સત્તાવીસ",
//     28: "અઠ્ઠાવીસ",
//     29: "ઓગણત્રીસ",
//     30: "ત્રીસ",
//     31: "એકત્રીસ",
//     32: "બત્રીસ",
//     33: "તેત્રીસ",
//     34: "ચોત્રીસ",
//     35: "પાંત્રીસ",
//     36: "છત્રીસ",
//     37: "સાડત્રીસ",
//     38: "અડત્રીસ",
//     39: "ઓગણચાલીસ",
//     40: "ચાલીસ",
//     41: "એકતાલીસ",
//     42: "બેતાલીસ",
//     43: "તેતાલીસ",
//     44: "ચુંમાલીસ",
//     45: "પિસ્તાલીસ",
//     46: "છેતાલીસ",
//     47: "સડતાલીસ",
//     48: "અડતાલીસ",
//     49: "ઓગણપચાસ",
//     50: "પચાસ",
//     51: "એકાવન",
//     52: "બાવન",
//     53: "ત્રેપન",
//     54: "ચોપન",
//     55: "પંચાવન",
//     56: "છપ્પન",
//     57: "સત્તાવન",
//     58: "અઠ્ઠાવન",
//     59: "ઓગણસાઠ",
//     60: "સાઠ",
//     61: "એકસઠ",
//     62: "બાસઠ",
//     63: "ત્રેસઠ",
//     64: "ચોસઠ",
//     65: "પાંસઠ",
//     66: "છાસઠ",
//     67: "સડસઠ",
//     68: "અડસઠ",
//     69: "ઓગણસિત્તેર",
//     70: "સિત્તેર",
//     71: "એકોતેર",
//     72: "બોતેર",
//     73: "તોતેર",
//     74: "ચુમોતેર",
//     75: "પંચોતેર",
//     76: "છોતેર",
//     77: "સડોતેર",
//     78: "અઠ્ઠોતેર",
//     79: "ઓગણએંસી",
//     80: "એંસી",
//     81: "એક્યાસી",
//     82: "બ્યાસી",
//     83: "ત્ર્યાસી",
//     84: "ચોર્યાસી",
//     85: "પંચ્યાસી",
//     86: "છ્યાસી",
//     87: "સડ્યાસી",
//     88: "અઠ્ઠ્યાસી",
//     89: "નેવ્યાસી",
//     90: "નેવું",
//     91: "એકાણું",
//     92: "બાણું",
//     93: "ત્રાણું",
//     94: "ચોરાણું",
//     95: "પંચાણું",
//     96: "છાણું",
//     97: "સત્તાણું",
//     98: "અઠ્ઠાણું",
//     99: "નવાણું",
//   };

//   const units = [
//     { value: 1000000000000000, label: "પદ્મ" }, // 10^15
//     { value: 10000000000000, label: "નીલ" }, // 10^13
//     { value: 100000000000, label: "ખરબ" }, // 10^11
//     { value: 1000000000, label: "અરબ" }, // 10^9
//     { value: 10000000, label: "કરોડ" }, // 10^7
//     { value: 100000, label: "લાખ" },
//     { value: 1000, label: "હજાર" },
//     { value: 100, label: "સો" },
//   ];

//   // 🔒 Force 2 decimals to avoid JS issues (1101.10 → "10")
//   const [intPart, decimalPart] = Number(num).toFixed(2).split(".");
//   let n = parseInt(intPart, 10);
//   console.log("checkingTheIntAndDecimalPart", intPart, decimalPart);

//   let words = "";
//   if (n === 0) {
//     words = "શૂન્ય રૂપિયા";
//   }

//   // Integer part
//   if (n >= 100) {
//     for (const unit of units) {
//       if (n >= unit.value) {
//         const count = Math.floor(n / unit.value);
//         words += map1To99[count] + " " + unit.label + " ";
//         n %= unit.value;
//       }
//     }
//   }

//   if (n > 0) words += map1To99[n];

//   words = words.trim() + " રૂપિયા";

//   // Paisa part (1–99 reading)
//   const paise = parseInt(decimalPart, 10);
//   if (paise > 0) {
//     words += " " + map1To99[paise] + " પૈસા";
//   }

//   return { words: words, decimalPart: decimalPart };
// }

export const toIndianCurrency = (number) => {
  if (number == null || isNaN(number)) return "";

  const formatted = number.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  });

  const answer = numberToHindiWords(number);

  return `${formatted} (${answer.words} )`;
};

export const toIndianCurrencyDashboardCard = (number) => {
  if (number == null || isNaN(number)) return null;

  const formatted = number.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  });

  const answer = numberToHindiWords(parseFloat(number));

  return (
    <>
      <div style={{ fontSize: "1.02em" }}>{formatted}</div>
      <div>
        {" "}
        <span style={{ fontSize: "0.95em", color: "#555" }}>({answer.words})</span>
      </div>
    </>
  );
};

export const toIndianCurrencyVillageCard = (number) => {
  if (number == null || isNaN(number)) return null;

  const formatted = number.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  });

  const answer = numberToHindiWords(parseFloat(number));

  return (
    <>
      <div style={{ fontSize: "1.4em" }}>{formatted}</div>
      <div>
        {" "}
        <span style={{ fontSize: "0.95em", color: "#555" }}>({answer.words})</span>
      </div>
    </>
  );
};

// export const toIndianCurrency = (number) => {
//   if (number == null || isNaN(number)) return null;

//   const formatted = number.toLocaleString("en-IN", {
//     style: "currency",
//     currency: "INR",
//     maximumFractionDigits: 2,
//   });

//   const answer = numberToGujaratiWords(parseFloat(number));

//   return (
//     <>
//       <div style={{ fontSize: "1.02em" }}>{formatted}</div>
//       <div>
//         {" "}
//         <span style={{ fontSize: "0.95em", color: "#555" }}>({answer.words})</span>
//       </div>
//     </>
//   );
// };

export const toOverallIndianCurrency = (number) => {
  if (number == null || isNaN(number)) return "";

  const formatted = number.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  });

  const answer = numberToHindiWords(number);

  return { formatted: formatted, answer: answer };
};

export const toIndianCurrencyHeader = (number) => {
  if (number == null || isNaN(number)) return null;

  const answer = numberToHindiWords(number);

  return (
    <>
      <div>
        <span style={{ fontSize: "0.95em", color: "#555" }}>({answer.words})</span>
      </div>
    </>
  );
};

// export const toIndianCurrency = (number) => {
//   if (number == null) return "";
//   return number.toLocaleString("en-IN", {
//     style: "currency",
//     currency: "INR",
//   });
// };

export const exportToMandaliDetailExcel = async (data, fileName = "Member_List", options = {}, bhajanMandaliType, VillageName) => {
  if (!data?.length) return;

  const { columnVertPadding = {} } = options; // <-- NEW

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Members");

  const headers = Object.keys(data[0]).filter((h) => h !== "_memberLength");
  const totalColumns = headers.length;

  const titleRow = worksheet.addRow([`${bhajanMandaliType}`]);
  worksheet.mergeCells(1, 1, 1, totalColumns);
  titleRow.height = 30;
  titleRow.getCell(1).font = { bold: true, size: 18, color: { argb: "FF2F75B5" } };
  titleRow.getCell(1).alignment = { horizontal: "center", vertical: "middle" };

  const subTitleRow = worksheet.addRow([`${VillageName}`]);
  worksheet.mergeCells(2, 1, 2, totalColumns);
  subTitleRow.height = 22;
  subTitleRow.getCell(1).font = { bold: true, size: 16, color: { argb: "FF2F75B5" } };
  subTitleRow.getCell(1).alignment = { horizontal: "center", vertical: "middle" };

  const borderColor = "FFCCCCCC";
  const headerBg = "FF2F75B5";
  const zebraLight = "FFF2F2F2";
  const zebraDark = "FFFFFFFF";

  // ---------- HEADER ----------
  const headerRow = worksheet.addRow(headers);
  let headerHeight = 22; // default
  headerRow.eachCell((cell, colNumber) => {
    const colName = headers[colNumber - 1];
    const pad = columnVertPadding[colName] ?? 0;

    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.alignment = {
      horizontal: "center",
      vertical: "middle",
      wrapText: true,
      // NO indent → no left/right padding
    };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: headerBg } };
    cell.border = {
      top: { style: "thin", color: { argb: borderColor } },
      bottom: { style: "thin", color: { argb: borderColor } },
      left: { style: "thin", color: { argb: borderColor } },
      right: { style: "thin", color: { argb: borderColor } },
    };

    if (pad > 0) {
      headerHeight = Math.max(headerHeight, 15 + pad * 2);
    }
  });
  headerRow.height = headerHeight;

  worksheet.views = [{ state: "frozen", ySplit: 3 }];

  let rowIdx = 2;
  let zebra = true;

  // ---------- DATA ----------
  for (let i = 0; i < data.length; ) {
    const head = data[i];
    const count = head._memberLength || 1;
    const startRow = rowIdx;
    const endRow = startRow + count - 1;
    const bgColor = zebra ? zebraLight : zebraDark;
    zebra = !zebra;

    // Step 1: First pass – collect max padding & estimate text height
    const rowHeights = Array(count).fill(0); // per-row min height
    const colMaxPad = new Map(); // per-column max padding in group

    for (let j = 0; j < count; j++) {
      const rowData = data[i + j];
      const values = headers.map((h) => rowData[h] ?? "");

      values.forEach((val, idx) => {
        const colName = headers[idx];
        const pad = columnVertPadding[colName] ?? 0;
        if (pad > 0) colMaxPad.set(colName, Math.max(colMaxPad.get(colName) || 0, pad));

        // Estimate lines (for wrapText)
        const lines = String(val).split("\n").length;
        const minHeight = Math.max(15, lines * 15); // 15pt per line
        rowHeights[j] = Math.max(rowHeights[j], minHeight);
      });
    }

    // Step 2: Compute final height per row (max of all influences)
    const finalRowHeights = rowHeights.map((base, j) => {
      let maxInRow = base;

      // Add padding from any column in this row
      headers.forEach((colName) => {
        const pad = columnVertPadding[colName] ?? 0;
        if (pad > 0) {
          maxInRow = Math.max(maxInRow, 15 + pad * 2);
        }
      });

      return maxInRow;
    });

    // Step 3: Apply rows with correct height
    for (let j = 0; j < count; j++) {
      const rowData = data[i + j];
      const row = worksheet.addRow(headers.map((h) => rowData[h] ?? ""));

      row.height = finalRowHeights[j]; // <-- final height

      row.eachCell((cell, colNumber) => {
        const colName = headers[colNumber - 1];

        cell.alignment = {
          wrapText: true,
          vertical: "middle",
          horizontal: typeof cell.value === "number" ? "right" : cell.value instanceof Date ? "center" : "left",
          // NO indent
        };
        cell.border = {
          top: { style: "thin", color: { argb: borderColor } },
          bottom: { style: "thin", color: { argb: borderColor } },
          left: { style: "thin", color: { argb: borderColor } },
          right: { style: "thin", color: { argb: borderColor } },
        };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
      });

      rowIdx++;
    }

    // ---- MERGE (Sr No, Name, etc.) ----
    ["Sr No", "Head Name", "Village", "Locality"].forEach((colName) => {
      const col = headers.indexOf(colName) + 1;
      if (startRow !== endRow) {
        worksheet.mergeCells(startRow, col, endRow, col);
        const merged = worksheet.getCell(startRow, col);
        merged.alignment = { vertical: "middle", horizontal: "left", wrapText: true };
      }
    });

    i += count;
  }

  // ---------- COLUMN WIDTH ----------
  worksheet.columns.forEach((col) => {
    const name = col.header;
    if (name === "Sr No") {
      col.width = 6;
      return;
    }
    let max = 10;
    col.eachCell({ includeEmpty: true }, (c) => {
      const len = c.value ? String(c.value).length : 0;
      if (len > max) max = len;
    });
    col.width = Math.min(max + 3, 60);
  });

  // ---------- AUTOFILTER ----------
  worksheet.autoFilter = {
    from: { row: 3, column: 1 },
    to: { row: 3, column: headers.length },
  };

  // ---------- SAVE ----------
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `${fileName}_${new Date().toISOString().slice(0, 10)}.xlsx`);
};
